<template>
  <div
    class="cart-view"
    :class="{
      'desktopCart': !$vuetify.breakpoint.smAndDown,
      'mobileCart': $vuetify.breakpoint.smAndDown
    }"
    style="max-width: 100% !important"
    ref="cart"
  >
  <div v-if="isDineInOnlyRoute">
    Dine-In (Table #{{getTableDisplay}})
  </div>
    <!-- <button style="position: absolute; top: 3px; right: 3px" @click="resetCart">Clear Cart</button> -->

    <!-- Group order header -->
    <div v-if="groupOrderSession" class="go-cart-header">
      <div class="go-cart-title-row">
        <div class="go-cart-title">{{ groupOrderSession.groupOrderName }}</div>
        <div class="go-menu-wrap" v-click-outside="() => { showGoMenu = false }">
          <button class="go-menu-btn" @click="showGoMenu = !showGoMenu">
            <v-icon size="20" color="white">more_horiz</v-icon>
          </button>
          <div v-if="showGoMenu" class="go-menu-dropdown">
            <button
              v-if="groupOrderSession.role === 'host'"
              class="go-menu-item"
              @click="goOpenInviteDialog(); showGoMenu = false"
            >{{ $vuetify.t('$vuetify.groupOrder.cartMenuInvite') }}</button>
            <button
              v-if="groupOrderSession.role === 'host'"
              class="go-menu-item go-menu-item-danger"
              @click="showCancelGroupConfirm = true; showGoMenu = false"
            >{{ $vuetify.t('$vuetify.groupOrder.cartMenuCancelGroup') }}</button>
            <button
              v-else
              class="go-menu-item go-menu-item-danger"
              @click="showLeaveGroupConfirm = true; showGoMenu = false"
            >{{ $vuetify.t('$vuetify.groupOrder.cartMenuLeaveGroup') }}</button>
          </div>
        </div>
      </div>
      <div v-if="!isPickUp" class="go-cart-meta"><span class="go-cart-meta-label">{{ $vuetify.t('$vuetify.groupOrder.from') }}</span><span class="go-cart-meta-value">{{ getStore && getStore.name }}</span></div>
      <div class="go-cart-meta"><span class="go-cart-meta-label">{{ isPickUp ? $vuetify.t('$vuetify.groupOrder.pickupAt') : $vuetify.t('$vuetify.groupOrder.deliverTo') }}</span><span class="go-cart-meta-value">{{ goDeliverToText }}</span></div>
      <div class="go-cart-meta" :style="isHostInGroupOrder ? 'cursor:pointer' : ''" @click="isHostInGroupOrder && SET_PICKUP_DELIVERY_EDIT_DIALOG(true)">
        <span class="go-cart-meta-label">{{ $vuetify.t('$vuetify.order.orderScheduled') }}</span>
        <span class="go-cart-meta-value">{{ goScheduledText }}<v-icon v-if="isHostInGroupOrder" small style="margin-left:4px;vertical-align:middle;opacity:0.7">edit</v-icon></span>
      </div>
      <div class="go-cart-meta"><span class="go-cart-meta-label">{{ $vuetify.t('$vuetify.order.payment') }}</span><span class="go-cart-meta-value">{{ goPaymentText }}</span></div>
      <div
        v-if="goDeadlineText"
        class="go-deadline-row"
        :class="{ 'go-deadline-row--editable': isHostInGroupOrder }"
        @click="isHostInGroupOrder && goOpenDeadlineDialog()"
      >
        <div class="go-deadline-icon-wrap"><v-icon color="white" size="14">schedule</v-icon></div>
        <span class="go-deadline-text">{{ $vuetify.t('$vuetify.groupOrder.orderBeforeDeadline', [goDeadlineText]) }}</span>
        <v-icon v-if="isHostInGroupOrder" small class="go-deadline-edit-icon">edit</v-icon>
      </div>
    </div>

    <!-- Group order locked banner -->
    <template v-if="groupOrderSession && groupOrderSession.locked && !($store.state.groupOrder && $store.state.groupOrder.removed)">
      <div v-if="groupOrderSession.role !== 'host'" class="go-locked-banner">
        {{ $vuetify.t('$vuetify.groupOrder.lockedBannerGuest') }}
      </div>
      <div v-else class="go-locked-banner go-locked-banner-host">
        {{ $vuetify.t('$vuetify.groupOrder.lockedBannerHost') }}
      </div>
    </template>

    <div style="max-width: 100% !important">
      <div ref="header">
        <!-- <order-type-select is-cart /> -->
        <!-- <div class="pt-3 pb-3 title" v-if="getStoreOrderTypes.length === 1 || (isDineIn && isDineInTableSet)">
          {{ cartTitle }}
        </div> -->
        <order-type-selector v-if="!(isDineInOnlyRoute || hasTableId) && !groupOrderSession && !isSharedCartActive" :store="getStore" :isCart="true" :small="true"/>
        <!-- Shared cart banner -->
        <div v-if="isSharedCartActive" class="sc-banner">
          <v-icon small color="white" style="margin-right: 4px">restaurant_menu</v-icon>
          {{ $vuetify.t('$vuetify.sharedCart.bannerLabel', [getTableDisplay]) }}
          <span v-if="sharedCartWsConnected" class="sc-connected-dot" :title="$vuetify.t('$vuetify.sharedCart.live')"></span>
        </div>
      <!-- Display a reactive Error report. cartErrorMessage includes the ORDER-level
           minimum (doesCartMeetOrderMinimum, group-total-aware) alongside item-level
           errors -- that's correct for the host (whose blockCheckout must reflect the
           whole group's total), but a guest only needs their OWN item-level errors
           (out-of-stock, disabled item): minimumOrderValueInCents was never meant to
           apply per-participant, so a guest below the store minimum on their own slice
           is not an error worth surfacing here. -->
      <div style="padding-left: 10px; padding-right: 10px; font-size: 13px !important; color: #e90e10; font-weight: 600; background: #F5F5F5; margin-bottom: 10px; padding-top: 5px; padding-bottom: 5px" v-if="displayedCartErrorMessage" class="errorStatus" v-html="displayedCartErrorMessage">
      </div>
        <hr v-if="!groupOrderSession" style="margin-top: 5px" />
        <template v-if="groupOrderSession">
          <div class="go-your-items-title">{{ $vuetify.t('$vuetify.groupOrder.yourItems') }}</div>
          <div class="go-my-name-row">
            <v-icon small>person</v-icon>
            <span>{{ groupOrderSession.myName }}</span>
          </div>
        </template>
        <div v-if="groupOrderSession ? !getOrderItemList.length : (!getLocalCart.length && !getExistingOrder.length)" class="pa-3 adding">
          {{ $vuetify.t('$vuetify.cart.startAdding') }}
        </div>
      </div>

      <div v-if="!getLocalCart.length && getExistingOrder.length" class="pa-3 subheading">
        {{ $vuetify.t('$vuetify.cart.buildOrder') }}
      </div>
      <ul v-if="(rewardOptions && rewardOptions.length) || (getPunchCards && getPunchCards.length) || (serverCoupons && serverCoupons.length) || (getOrderItemList && getOrderItemList.length)" class="cart-list-main cart-list cart-list-container text-xs-left py-2" style="max-width: 100% !important">
        <div v-if="!isSharedCartActive && (!$store.getters['groupOrder/isInGroupOrder'] || $store.state.groupOrder.isHost) && ((rewardOptions && rewardOptions.length) || (getPunchCards && getPunchCards.length) || (serverCoupons && serverCoupons.length))" class="cart-promotions-container">
          <div class="cart-promo-list">
            <!-- <reward-options-card 
              v-for="rewardOption in rewardOptions"
              :key="rewardOption.id"
              :reward-option="rewardOption"
              only-available
              max-width="100%"
              class="promo-card mb-2"
            /> -->
            <reward-options-card-detail
              v-for="rewardOption in rewardOptions.filter(r => r.type !== 'coupon')"
              :key="rewardOption.id"
              :reward-option="rewardOption"
              only-available
              max-width="100%"
              class="promo-card mb-2"
            />

            <template v-if="isLoggedIn">
              <!-- <punch-card 
                v-for="punchCard in getPunchCards"
                :key="punchCard.id"
                :punchCard="punchCard"
                max-width="100%"
                class="promo-card mb-2"
              /> -->
              <punch-card-detail
                v-for="punchCard in getPunchCards"
                :key="punchCard.id"
                :punchCard="punchCard"
                max-width="100%"
                class="promo-card mb-2"
              />
<!-- 
              <coupon-card 
                v-for="coupon in serverCoupons"
                :coupon="coupon"
                :key="coupon.code"
                showItems
                allowConfig
                max-width="100%"
                class="promo-card mb-2"
              /> -->
              <coupon-card-detail
                v-for="coupon in serverCoupons"
                :coupon="coupon"
                :key="coupon.code"
                showItems
                allowConfig
                max-width="100%"
                class="promo-card mb-2"
              />
            </template>
          </div>
        </div>

        <v-switch
          v-if="isDineIn && !isSharedCartActive && getOrderItemList.length && showTakeout"
          class="pl-3"
          v-model="isTakeout"
          hide-details="auto"
        >
          <template v-slot:label>
            <span :class="{ 'font-weight-bold': isTakeout }">
              {{ $vuetify.t('$vuetify.cart.takeOutOrder') }}
            </span>
          </template>
        </v-switch>

        <!-- Shared cart: fired rounds collapse into one "Already ordered" panel,
             separate from the still-editable "Adding now" draft below it, so a
             diner can tell at a glance what's locked vs. what they can still
             change without scrolling past every past round's full item list. -->
        <div v-if="isSharedCartActive && scOrderedRounds.length" class="sc-ordered-panel">
          <button type="button" class="sc-panel-header" @click="scOrderedExpanded = !scOrderedExpanded">
            <span class="sc-panel-title">{{ $vuetify.t('$vuetify.sharedCart.alreadyOrdered') }}</span>
            <v-icon small>{{ scOrderedExpanded ? 'expand_less' : 'expand_more' }}</v-icon>
          </button>
          <div v-if="!scOrderedExpanded" class="sc-round-summary-list">
            <div v-for="round in scOrderedRounds" :key="`sc-round-summary-${round.seq}`" class="sc-round-summary-row">
              <span v-if="formatSharedCartRoundTime(round.createTime)">{{ formatSharedCartRoundTime(round.createTime) }} · </span>{{ $vuetify.t('$vuetify.sharedCart.itemCount', [round.items.length]) }}
            </div>
          </div>
          <template v-else>
            <div v-for="round in scOrderedRounds" :key="`sc-round-${round.seq}`" class="sc-round-group">
              <div class="sc-section-header sc-round-header">
                <span>{{ formatSharedCartRoundTime(round.createTime) }} · {{ $vuetify.t('$vuetify.sharedCart.itemCount', [round.items.length]) }}</span>
              </div>
              <ul class="cart-list-main cart-list text-xs-left">
                <template v-for="(item, index) in round.items">
                  <li :key="index" class="pt-2 mb-2 pr-1 sc-sent-item" :class="{ 'has-errors': doesItemHaveErrors(item) }">
                    <v-layout row wrap v-if="doesItemHaveErrors(item)">
                      <v-flex v-for="(error, errIdx) in getItemErrors(item)" :key="`error[${errIdx}]`" xs12 class="pl-2 font-weight-bold text--error">
                        {{ `- ${error.errorMsg}` }}
                      </v-flex>
                    </v-layout>
                    <template v-if="!!item.childItemList && !!item.childItemList.length">
                      <cart-menu-item-display
                        :item="item"
                        :price="item.itemPrice-item.relationPrice"
                        :index="index"
                        :cartIsLoading="cartIsLoadingOrLocked"
                        :immutable="true"
                        :isPartOfQuantityBasedPromotion="isQuantityBasedPromotion(item)"
                        :key="`${item.uuid || item.code || index}-${item.qty}-${getServerCart && getServerCart.modifiedDate}`"
                      />
                      <div v-for="child in item.childItemList" style="margin-top: 10px !important; padding-left: 33.33% !important" :key="child.uuid">
                        <template v-if="child.childItemList && child.childItemList.length && child.childItemList[0].code != -1">
                          <b style="font-size: var(--text-size-1); margin-left: 16px;">
                            {{ child.name | capatalize }}
                          </b>
                          <cart-menu-item-display v-for="side of child.childItemList"
                            :key="`${side.code}-${getServerCart && getServerCart.modifiedDate}`"
                            :parent="child"
                            :item="side"
                            :index="index"
                            :isSide="true"
                            :quantity="item.qty"
                            :cartIsLoading="cartIsLoadingOrLocked"
                            :immutable="true"
                            :isPartOfQuantityBasedPromotion="isQuantityBasedPromotion(item)"
                          />
                        </template>
                      </div>
                    </template>
                    <cart-menu-item-display v-else :item="item" :index="index" :cartIsLoading="cartIsLoadingOrLocked"
                      :immutable="true"
                      :isPartOfQuantityBasedPromotion="isQuantityBasedPromotion(item)"
                      :key="`${item.uuid || item.code || index}-${item.qty}-${getServerCart && getServerCart.modifiedDate}`"
                    />
                  </li>
                </template>
              </ul>
            </div>
          </template>
        </div>

        <div v-if="isSharedCartActive && scDraftItems.length" class="sc-draft-header">
          <div class="sc-draft-title">{{ $vuetify.t('$vuetify.sharedCart.stillOrdering') }}</div>
          <div class="sc-draft-count">{{ $vuetify.t('$vuetify.sharedCart.itemCount', [scDraftItems.length]) }}</div>
        </div>

        <template v-for="(item, index) in (isSharedCartActive ? scDraftItems : getOrderItemList)">
          <li
            v-if="getOrderItemList && getOrderItemList.length"
            :key="index"
            class="pt-2 mb-2 pr-1"
            :class="{ 'has-errors': doesItemHaveErrors(item) }"
          >
            <v-layout row wrap v-if="doesItemHaveErrors(item)">
              <v-flex v-for="(error, errIdx) in getItemErrors(item)" :key="`error[${errIdx}]`" xs12 class="pl-2 font-weight-bold text--error">
                {{ `- ${error.errorMsg}` }}
              </v-flex>
            </v-layout>

            <!-- Shared cart stale item warning -->
            <div v-if="isSharedCartActive && isSharedCartItemStale(item.uuid)" class="sc-stale-badge">
              {{ $vuetify.t('$vuetify.sharedCart.staleItemWarning') }}
            </div>

            <template v-if="!!item.childItemList && !!item.childItemList.length">
              <cart-menu-item-display
                :item="item"
                :price="item.itemPrice-item.relationPrice"
                :index="index"
                :cartIsLoading="cartIsLoadingOrLocked"
                :isPartOfQuantityBasedPromotion="isQuantityBasedPromotion(item)"
                :key="`${item.uuid || item.code || index}-${item.qty}-${getServerCart && getServerCart.modifiedDate}`"
              />

              <div v-for="(child, childIndex) in item.childItemList" style="margin-top: 10px !important; padding-left: 33.33% !important" :key="child.uuid">
                <template v-if="child.childItemList && child.childItemList.length && child.childItemList[0].code != -1">
                  <b style="font-size: var(--text-size-1); margin-left: 16px;">
                    {{ child.name | capatalize }}
                  </b>

                  <cart-menu-item-display v-for="side of child.childItemList"
                    :key="`${side.code}-${getServerCart && getServerCart.modifiedDate}`"
                    :parent="child"
                    :item="side"
                    :index="index"
                    :isSide="true"
                    :quantity="item.qty"
                    :cartIsLoading="cartIsLoadingOrLocked"
                    :isPartOfQuantityBasedPromotion="isQuantityBasedPromotion(item)"
                  />
                </template>
              </div>
            </template>
            <cart-menu-item-display v-else :item="item" :index="index" :cartIsLoading="cartIsLoadingOrLocked"
              :isPartOfQuantityBasedPromotion="isQuantityBasedPromotion(item)"
              :key="`${item.uuid || item.code || index}-${item.qty}-${getServerCart && getServerCart.modifiedDate}`"
            />
          </li>
        </template>
      </ul>

      <!-- Others in your group (read-only) -->
      <div v-if="groupOrderSession && groupOrderSession.members && groupOrderSession.members.length" class="go-others-section">
        <hr class="go-section-divider" />
        <div class="go-others-title">{{ $vuetify.t('$vuetify.groupOrder.othersInGroup', [groupOrderSession.members.length]) }}</div>
        <div class="go-others-sub">{{ groupOrderSession.members.filter(function(m) { return m.items && m.items.length; }).length }} of {{ groupOrderSession.members.length }} have added items</div>
        <v-expansion-panel>
          <v-expansion-panel-content v-for="(member, midx) in groupOrderSession.members" :key="midx">
            <template v-slot:header>
              <div class="go-member-row">
                <v-icon small :color="member.items && member.items.length ? '' : '#bbb'">person</v-icon>
                <div class="go-member-name-block">
                  <span class="go-member-name" :class="{ 'go-member-name--empty': !member.items || !member.items.length }">
                    {{ member.name }}{{ member.isHost ? ' ' + $vuetify.t('$vuetify.groupOrder.memberHostLabel') : '' }}
                  </span>
                  <div class="go-member-status-row">
                    <span v-if="member.stage === 'READY'" class="go-member-ready-badge">{{ $vuetify.t('$vuetify.groupOrder.memberReadyBadge') }}</span>
                    <span v-else class="go-member-waiting-badge">{{ $vuetify.t('$vuetify.groupOrder.memberWaitingBadge') }}</span>
                    <span class="go-member-item-count">· {{ (member.items || []).reduce(function(s, i) { return s + (i.qty || 1) }, 0) }} item{{ (member.items || []).reduce(function(s, i) { return s + (i.qty || 1) }, 0) !== 1 ? 's' : '' }}</span>
                    <span v-if="memberHasErrors(member)" class="go-member-error-badge">{{ $vuetify.t('$vuetify.groupOrder.memberErrorBadge') }}</span>
                  </div>
                </div>
              </div>
            </template>
            <div class="go-member-items-body">
              <div v-for="(item, iidx) in (member.items || [])" :key="iidx" class="go-member-item-row-wrap" :class="{ 'has-errors': doesItemHaveErrors(item) }">
                <!-- Guest items are read-only here, but a guest's out-of-stock item (etc.)
                     still blocks the group -- the host needs to see it, not just the guest
                     on their own device (see doesItemHaveErrors/getItemErrors above, same
                     fields, already populated for every participantCarts entry). -->
                <v-layout row wrap v-if="doesItemHaveErrors(item)">
                  <v-flex v-for="(error, errIdx) in getItemErrors(item)" :key="`error[${errIdx}]`" xs12 class="pl-2 font-weight-bold text--error">
                    {{ `- ${error.errorMsg}` }}
                  </v-flex>
                </v-layout>
                <div class="go-member-item-row">
                  <!-- TODO: host participant cart mutation not yet supported by backend
                  <div class="go-member-item-controls" v-if="groupOrderSession.role === 'host'">
                    <button class="go-qty-btn" @click.stop="goDecrementMemberItem(midx, iidx)"><v-icon small>remove_circle_outline</v-icon></button>
                    <span class="go-qty-num">{{ item.qty || 1 }}</span>
                    <button class="go-qty-btn" @click.stop="goIncrementMemberItem(midx, iidx)"><v-icon small>add_circle_outline</v-icon></button>
                  </div>
                  -->
                  <div class="go-member-item-qty">{{ item.qty || 1 }}x</div>
                  <span class="go-member-item-name">{{ item.name }}</span>
                  <span class="go-member-item-price">${{ ((item.itemPrice || item.price || 0) * (item.qty || 1)).toFixed(2) }}</span>
                </div>
                <div v-if="item.specialRequest" class="go-member-item-special-request">{{ item.specialRequest }}</div>
              </div>
              <div v-if="!member.items || !member.items.length" class="go-member-empty">{{ $vuetify.t('$vuetify.groupOrder.memberNoItems') }}</div>
              <div v-if="groupOrderSession.role === 'host'" class="go-member-actions">
                <button
                  class="go-remove-member-btn"
                  @click.stop="goRemoveMember(midx)"
                >
                  {{ $vuetify.t('$vuetify.groupOrder.removeMember', [member.name]) }}
                </button>
              </div>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </div>

      <div v-if="(shouldSkipCheckout || allowAnonymous) && isDineIn && !isDisableSpecialRequest()" style="padding: 5px 10px">
        <v-textarea
          v-model="orderNotes"
          rows="3"
          :label="$vuetify.t('$vuetify.order.orderNotes')"
          :placeholder="$vuetify.t('$vuetify.checkout.orderHints')"
        ></v-textarea>
      </div>

      <v-divider></v-divider>
      <!-- SUB ORDER DISPLAY -->
      <!-- Shared cart: fired rounds are already shown inline above via the
           "Sent to Kitchen" section, so skip the generic Past Orders panel
           to avoid showing the same items twice. -->

      <span v-if="!isSharedCartActive && getExistingOrder.length">
        <v-expansion-panel>
          <!-- TODO -->
           <!-- @click.native="subOrderRefresh()" -->
          <v-expansion-panel-content>
            <template v-slot:header>
              <div>{{ $vuetify.t('$vuetify.cart.pastOrders') }}</div>
            </template>

            <div v-for="(subOrder, index) in getExistingOrder" :key="index">
              <reward-options-card v-for="rewardOption in subOrder.redemptionItems"
                :key="rewardOption.id"
                :reward-option="rewardOption"
                max-width="350px"
              />

              <template v-if="isLoggedIn">
                <!-- <punch-card v-for="punchCard in subOrder.punchCards"
                  :key="punchCard.id"
                  :punchCard="punchCard"
                  history
                /> -->
                <punch-card-detail v-for="punchCard in subOrder.punchCards"
                  :key="punchCard.id"
                  :punchCard="punchCard"
                />
              </template>

               <template v-for="coupon in subOrder.coupons">
                 <!-- <coupon-card v-if="coupon.orderItem"
                   :coupon="coupon"
                   :key="coupon.code"
                   showItems
                   immutable
                 /> -->
                 <coupon-card-detail v-if="coupon.orderItem"
                   :coupon="coupon"
                   :key="coupon.code"
                   showItems
                   immutable
                 />
               </template>

              <ul class="cart-list-main cart-list text-xs-left">
                <li v-for="(item, index) in subOrder.orderItemList" :key="index" class="pt-2">
                  <v-layout row class="pl-4">
                    <v-flex xs12>
                      <div>
                        <v-icon small color="error" v-if="subOrder.orderStatus === 'CANCELLED' || item.status === 'CANCELLED'">
                          cancel
                        </v-icon>
                        <v-icon small color="info" v-if="subOrder.orderStatus === 'SUBMITTED' && item.status !== 'CANCELLED'">
                          access_time
                        </v-icon>
                        <v-icon small color="success" v-if="subOrder.orderStatus === 'ACCEPTED' && item.status !== 'CANCELLED'">
                          check_circle
                        </v-icon>

                        <span :class="subOrder.orderStatus === 'CANCELLED' || item.status === 'CANCELLED' ? 'strikethrough' : ''">
                          {{ item.name }}
                        </span>
                      </div>
                    </v-flex>

                    <v-flex xs2 class="text-xs-right" :class="{'strikethrough': subOrder.orderStatus === 'CANCELLED' || item.status === 'CANCELLED'}">
                      {{ item.price | currency }}
                    </v-flex>
                  </v-layout>

                  <ul class="cart-list">
                    <li v-for="(config, index) in fetchConfigItemsSubOrder(item)" :key="index">
                      <v-layout row justify-space-between align-center>
                        <v-flex offset-xs4 xs6 :class="config.status === 'CANCELLED' || subOrder.orderStatus === 'CANCELLED' || item.status === 'CANCELLED' ? 'strikethrough pt-1' : 'pt-1'">
                          {{config.name}}
                        </v-flex>
                        <v-flex :class="item.status === 'CANCELLED' || config.status === 'CANCELLED' || subOrder.orderStatus === 'CANCELLED' ? 'strikethrough text-xs-right' : 'text-xs-right'" xs2>
                          {{ config.price | currency }}
                        </v-flex>
                      </v-layout>
                    </li>
                    <li>
                      <v-layout row justify-space-between align-center>
                        <v-flex offset-xs4 class="special-request" :class="subOrder.orderStatus === 'CANCELLED' || item.status === 'CANCELLED' ? 'strikethrough' : ''">
                          {{item.specialRequest}}
                        </v-flex>
                      </v-layout>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-divider></v-divider>
      </span>

      <!-- DEV-11115: AI recommendations row (shared with the checkout page). Lives inside
           the scrollable items region, under the item list, above the totals footer below. -->
      <ai-recommendations-row v-if="showAiCartRecommendations" />
    </div>
    <v-btn
      v-if="shouldShowStartShoppingButton && (!groupOrderSession || isSharedCartActive)"
      :loading="cartIsLoading"
      :disabled="!storeIsAvailable"
      @click="closeScroll"
      color="primary"
      class="rounded-btn"
      block
    >
      <div>
       {{ $vuetify.t('$vuetify.cart.startShopping') }}
      </div>
    </v-btn>

    <div id="footerContainer" :class="{ 'go-footer': !!groupOrderSession }" v-if="(getOrderItemList && getOrderItemList.length) || (groupOrderSession && $store.getters['groupOrder/groupSubTotal'] > 0) || hasAppliedReward || hasActiveCouponOrderItem">
      <div class="cart-totals" ref="cartFooter">
        <!-- <div v-if="isDelivery && getDeliveryMin" class="cart-faded" style="margin: 0px auto 10px">
          {{ $vuetify.t('$vuetify.cart.deliveryMinimum') }}:
          <span> {{ getDeliveryMin | currency }} </span>
        </div>
        <div v-else-if="isPickUp && getPickupMin" class="cart-faded" style="margin: 0px auto 10px">
          {{ $vuetify.t('$vuetify.cart.pickupMinimum') }}:
          <span> {{ getPickupMin | currency }} </span>
        </div> -->

        <template v-if="groupOrderSession">
          <div>
            {{ $vuetify.t('$vuetify.cart.subtotal') }}
            <span> {{ $currency($store.getters['groupOrder/groupSubTotal'], true, true) }} </span>
          </div>
          <div class="cart-faded" style="font-size: 12px;">
            {{ $vuetify.t('$vuetify.groupOrder.feesCalculatedAtCheckout') }}
          </div>
        </template>

        <template v-else>
          <div>
            {{ $vuetify.t('$vuetify.cart.subtotal') }}
            <span> {{ $currency(getServerCart.subTotal, true, true) }} </span>
          </div>

          <div v-if="(showDiscountLine() || hasDisplayableCoupons)">
            <div v-if="showDiscountLine()">
              {{ $vuetify.t('$vuetify.cart.discount') }}
              <span class="red--text"> {{getServerCart.discountTotal | currency}} </span>
            </div>

            <div v-if="cappedDiscountText" class="pl-2 caption">
              {{ cappedDiscountText }}
            </div>

            <template v-for="(coupon, couponIndex) in displayableCoupons">
              <div
                  :key="`coupon_${couponIndex}`"
                  :class="{ 'red--text': !_isCouponValid(coupon) }"
                >
                <v-icon @click="onRemoveCoupon()" small style="position: relative; top: -2px">
                  cancel
                </v-icon>

                {{ coupon.code }}

                <v-tooltip bottom v-if="coupon.description" max-width="300px">
                  <template v-slot:activator="{ on }">
                    <v-icon small v-on="on">
                      info
                    </v-icon>
                  </template>

                  {{ coupon.description }}
                </v-tooltip>

                <div v-for="(rule, ruleIndex) in getInvalidRules(coupon)"
                  :key="`rule_${couponIndex}_${ruleIndex}`"
                  class="pl-2 caption"
                  style="float: right"
                >
                  - {{ rule.description }}
                </div>
              </div>
            </template>
          </div>

          <div v-if="isDelivery" class="cart-faded">
            {{ $vuetify.t('$vuetify.cart.deliveryFee') }}
            <span v-if="hasFreeDeliveryCoupon">
              {{ $vuetify.t('$vuetify.account.rewards.free') }}
            </span>
            <span v-else-if="isDeliveryAddressSet() && doesCartMeetDeliveryMinimum">
              <template v-if="getServerCart.deliveryCharge === 0 || getServerCart.deliveryCharge === 0.0">
                {{ $vuetify.t('$vuetify.account.rewards.free') }}
              </template>
              <template v-else>
                {{ getServerCart.deliveryCharge | currency }}
              </template>
            </span>
            <span v-else>{{ $vuetify.t('$vuetify.cart.tbd') }}</span>
          </div>

          <div v-for="(charge, chIndex) in getServiceCharges" :key="`charge_${chIndex}`" class="cart-faded">
            {{ charge.name || $vuetify.t('$vuetify.cart.serviceFee') }}

            <v-tooltip bottom v-if="charge.info">
              <template v-slot:activator="{ on }">
                <v-icon small v-on="on">
                  info
                </v-icon>
              </template>

              {{ charge.info }}
            </v-tooltip>

            <span>
              {{ (charge.amount || 0) | currency }}
            </span>
          </div>

          <div>
            {{ $vuetify.t('$vuetify.cart.tax') }}
            <span v-if="isDeliveryAddressSet()"> {{ $currency(getServerCart.taxTotal, true, true) }} </span>
            <span v-else> TBD </span>
          </div>

          <template v-if="showTaxDetail && isDeliveryAddressSet() && Object.keys(getServerCart.taxDetail || {}).filter(_key => _key != 'hst').length > 1">
            <template v-for="key of Object.keys(getServerCart.taxDetail || {})">
            <div v-if="key != 'hst' && !!getServerCart.taxDetail[key] && typeof getServerCart.taxDetail[key] === 'number'" class="cart-faded" style="padding-left: 10px">
              {{ key.toUpperCase() }}
              <span> {{ $currency(getServerCart.taxDetail[key], true, true) }} </span>
            </div>
            </template>
          </template>

          <div class="cart-grand-total">
            {{ $vuetify.t('$vuetify.cart.total') }}
            <span v-if="isDeliveryAddressSet() && doesCartMeetDeliveryMinimum"> {{getServerCart.total | currency}} </span>
            <span v-else> TBD </span>
          </div>

          <div v-if="getServerCart.rewardPoints > 0">
            {{ $vuetify.t('$vuetify.cart.rewards') }}
            <span>{{getServerCart.rewardPoints}} pts</span>
          </div>
        </template>
      </div>

      <!-- Normal checkout button -->
      <v-btn
          v-if="!groupOrderSession && !isSharedCartActive"
          :disabled="blockCheckout || cartIsLoading"
          :loading="cartIsLoading"
          @click="checkoutAction"
          color="primary"
          id="checkBtn"
          block
        >
          <div v-if="shouldShowStartShoppingButton">
              {{ $vuetify.t('$vuetify.cart.startShopping') }}
          </div>
          <div v-else-if="!isLoggedIn">
              {{ $vuetify.t('$vuetify.cart.continue') }}
          </div>
          <div v-else-if="multiIsVisible(!canCheckout)">
            <span v-if="canCheckout">
              Pay
            </span>
            <span v-else-if="hasOrder">
              {{ $vuetify.t('$vuetify.cart.btnSubmitSubOrder') }}
            </span>
            <span v-else-if="!getLocalCart.length && getExistingOrder.length">
              {{ $vuetify.t('$vuetify.cart.processing') }}
            </span>
          </div>
          <div v-else-if="shouldSkipCheckout && isDineIn">
            {{ $vuetify.t('$vuetify.cart.btnPayOrder') }}
          </div>
          <div v-else>
            {{ $vuetify.t('$vuetify.cart.btnCheckout') }}
          </div>
        </v-btn>
      <!-- <Login :hideClose="true"/> -->
    </div>

    <!-- Shared cart action buttons -->
    <div v-if="isSharedCartActive && getOrderItemList && getOrderItemList.length" class="sc-action-btns">
      <button
        v-if="sharedCartHasDraftItems"
        class="sc-fire-btn"
        :disabled="scFireLoading"
        @click="scFireRound"
      >
        {{ scFireLoading ? $vuetify.t('$vuetify.sharedCart.sending') : $vuetify.t('$vuetify.cart.btnPayOrder') }}
      </button>
    </div>

    <!-- Group order action buttons (outside footerContainer so they show even with empty cart) -->
    <div v-if="groupOrderSession" class="go-action-btns">
      <!-- HOST actions -->
      <template v-if="groupOrderSession.role === 'host'">
        <!-- blockCheckout already includes cartErrorMessage (out-of-stock items etc.) --
             goOpenCheckoutConfirm already refuses to open the dialog when blocked, this
             just makes the button LOOK disabled instead of staying fully clickable-looking
             while doing nothing, matching the normal (non-group) cart's checkout button. -->
        <button class="go-ready-btn" :disabled="goCheckoutLoading || goTotalItemCount === 0 || blockCheckout" @click="goOpenCheckoutConfirm">
          {{ goCheckoutLoading ? $vuetify.t('$vuetify.groupOrder.checkoutProcessing') : $vuetify.t('$vuetify.groupOrder.goToCheckout') }}
        </button>
      </template>

      <!-- GUEST: locked by countdown (can't change anything) -->
      <template v-else-if="groupOrderSession.locked && groupOrderSession.lockedReason === 'COUNTDOWN'">
        <button class="go-locked-btn" disabled>{{ $vuetify.t('$vuetify.groupOrder.lockedTimeoutBtn') }}</button>
      </template>

      <!-- GUEST: locked for checkout — red banner above already communicates this -->
      <template v-else-if="groupOrderSession.locked && groupOrderSession.lockedReason === 'CHECKOUT'">
      </template>

      <!-- GUEST: marked ready — adding/editing items auto-unreadies via backend -->
      <template v-else-if="$store.state.groupOrder.participantCart && $store.state.groupOrder.participantCart.stage === 'READY'">
        <div class="go-ready-status">
          <span class="go-ready-dot"></span>
          {{ $vuetify.t('$vuetify.groupOrder.readyStatus') }}
        </div>
        <button class="go-add-items-outline-btn" @click="$emit('closeCart')">{{ $vuetify.t('$vuetify.groupOrder.addItemsBtn') }}</button>
      </template>

      <!-- GUEST: not ready yet -->
      <template v-else>
        <!-- displayedCartErrorMessage is scoped to this guest's own item-level errors
             (groupOrder/cartValidationErrors), not the ORDER-level minimum
             (doesCartMeetOrderMinimum) cartErrorMessage also blocks on for the host --
             see displayedCartErrorMessage's own comment. -->
        <button class="go-ready-btn" :disabled="!$store.getters['groupOrder/myCartItems'].length || !!displayedCartErrorMessage" @click="goMarkReady">{{ $vuetify.t('$vuetify.groupOrder.imReadyBtn') }}</button>
        <button class="go-add-items-outline-btn" @click="$emit('closeCart')">{{ $vuetify.t('$vuetify.groupOrder.addItemsBtn') }}</button>
      </template>
    </div>

    <!-- Remove member inline confirm -->
    <div v-if="showRemoveConfirm && removeConfirmMember" class="go-inline-confirm">
      <div class="go-inline-confirm-card">
        <button class="go-remove-confirm-x" @click="showRemoveConfirm = false; removeConfirmMember = null"><v-icon size="18">close</v-icon></button>
        <div class="go-remove-confirm-title">{{ $vuetify.t('$vuetify.groupOrder.removeConfirmTitle', [removeConfirmMember.name]) }}</div>
        <div class="go-remove-confirm-sub">{{ $vuetify.t('$vuetify.groupOrder.removeConfirmBody', [removeConfirmMember.name]) }}</div>
        <button class="go-remove-confirm-btn" @click="goConfirmRemove">{{ $vuetify.t('$vuetify.groupOrder.removeConfirmBtn', [removeConfirmMember.name]) }}</button>
        <button class="go-remove-cancel-btn" @click="showRemoveConfirm = false; removeConfirmMember = null">{{ $vuetify.t('$vuetify.common.cancel') }}</button>
      </div>
    </div>

    <!-- Leave group order inline confirm -->
    <div v-if="showLeaveGroupConfirm" class="go-inline-confirm">
      <div class="go-inline-confirm-card">
        <button class="go-remove-confirm-x" @click="showLeaveGroupConfirm = false"><v-icon size="18">close</v-icon></button>
        <div class="go-remove-confirm-title">{{ $vuetify.t('$vuetify.groupOrder.leaveConfirmTitle') }}</div>
        <div class="go-remove-confirm-sub">{{ $vuetify.t('$vuetify.groupOrder.leaveConfirmBody') }}</div>
        <button class="go-remove-confirm-btn" :disabled="leaveGroupLoading" @click="goConfirmLeaveGroup">
          {{ leaveGroupLoading ? '...' : $vuetify.t('$vuetify.groupOrder.leaveConfirmBtn') }}
        </button>
        <button class="go-remove-cancel-btn" @click="showLeaveGroupConfirm = false">{{ $vuetify.t('$vuetify.groupOrder.leaveConfirmKeep') }}</button>
      </div>
    </div>

    <!-- Cancel group order inline confirm -->
    <div v-if="showCancelGroupConfirm" class="go-inline-confirm">
      <div class="go-inline-confirm-card">
        <button class="go-remove-confirm-x" @click="showCancelGroupConfirm = false"><v-icon size="18">close</v-icon></button>
        <div class="go-remove-confirm-title">{{ $vuetify.t('$vuetify.groupOrder.cancelGroupOrderConfirmTitle', [(groupOrderSession && groupOrderSession.groupOrderName) || $store.getters['groupOrder/groupName']]) }}</div>
        <div class="go-remove-confirm-sub">{{ $vuetify.t('$vuetify.groupOrder.cancelGroupOrderConfirmBody') }}</div>
        <button class="go-remove-confirm-btn" :disabled="cancelGroupLoading" @click="goConfirmCancelGroup">
          {{ cancelGroupLoading ? '...' : $vuetify.t('$vuetify.groupOrder.cancelGroupOrderConfirm') }}
        </button>
        <button class="go-remove-cancel-btn" @click="showCancelGroupConfirm = false">{{ $vuetify.t('$vuetify.groupOrder.cancelGroupOrderKeep') }}</button>
      </div>
    </div>

    <!-- Some guests aren't ready — two-option confirm (DEV-10330) -->
    <div v-if="showCheckoutConfirm && goNotReadyCount > 0" class="go-inline-confirm">
      <div class="go-inline-confirm-card go-unready-confirm-card">
        <button class="go-remove-confirm-x" :disabled="goCheckoutLoading || goRemoveCartsLoading" @click="showCheckoutConfirm = false"><v-icon size="18">close</v-icon></button>
        <div class="go-remove-confirm-title">{{ goUnreadyConfirmTitle }}</div>
        <div v-if="goUnreadyMembers.length > 1" class="go-remove-confirm-sub">
          {{ $vuetify.t('$vuetify.groupOrder.unreadyConfirmWaitingOnPrefix') }}<b>{{ goUnreadyNamesText }}</b>{{ $vuetify.t('$vuetify.groupOrder.unreadyConfirmWaitingOnSuffix') }}
        </div>
        <div class="go-remove-confirm-sub">{{ $vuetify.t('$vuetify.groupOrder.unreadyConfirmBody') }}</div>

        <button class="go-ready-btn go-checkout-confirm-btn go-checkout-btn-with-subtext" :disabled="goCheckoutLoading || goRemoveCartsLoading" @click="goHostCheckout">
          <span class="go-checkout-btn-title">{{ goCheckoutLoading ? $vuetify.t('$vuetify.groupOrder.checkoutProcessing') : $vuetify.t('$vuetify.groupOrder.checkoutWithCurrentBtn') }}</span>
          <span v-if="!goCheckoutLoading" class="go-checkout-btn-subtext">{{ $vuetify.t('$vuetify.groupOrder.checkoutWithCurrentSubtext') }}</span>
        </button>
        <button class="go-remove-carts-checkout-btn go-checkout-btn-with-subtext" :disabled="goCheckoutLoading || goRemoveCartsLoading" @click="goRemoveUnreadyAndCheckout">
          <span class="go-checkout-btn-title">{{ goRemoveCartsLoading ? $vuetify.t('$vuetify.groupOrder.checkoutProcessing') : $vuetify.t('$vuetify.groupOrder.removeCartsCheckoutBtn') }}</span>
          <span v-if="!goRemoveCartsLoading" class="go-checkout-btn-subtext">{{ $vuetify.t('$vuetify.groupOrder.removeCartsCheckoutSubtext') }}</span>
        </button>
        <button class="go-remove-cancel-btn go-checkout-back-btn" :disabled="goCheckoutLoading || goRemoveCartsLoading" @click="showCheckoutConfirm = false">{{ $vuetify.t('$vuetify.groupOrder.checkoutBackBtn') }}</button>
      </div>
    </div>

    <!-- Is everyone ready? checkout confirm (everyone ready -- unchanged) -->
    <div v-else-if="showCheckoutConfirm" class="go-inline-confirm">
      <div class="go-inline-confirm-card">
        <button class="go-remove-confirm-x" @click="showCheckoutConfirm = false"><v-icon size="18">close</v-icon></button>
        <div class="go-remove-confirm-title">{{ $vuetify.t('$vuetify.groupOrder.checkoutConfirmTitle') }}</div>
        <div class="go-remove-confirm-sub">{{ $vuetify.t('$vuetify.groupOrder.checkoutConfirmBody') }}</div>

        <!-- Participant readiness list -->
        <div v-if="groupOrderSession && groupOrderSession.members && groupOrderSession.members.length" class="go-readiness-list">
          <div v-for="(member, i) in groupOrderSession.members" :key="i" class="go-readiness-row">
            <v-icon size="16" :color="member.stage === 'READY' ? 'success' : (member.locked ? '#888' : '#bbb')">
              {{ member.stage === 'READY' ? 'check_circle' : (member.locked ? 'lock' : 'radio_button_unchecked') }}
            </v-icon>
            <span :style="{ color: member.stage === 'READY' ? '#333' : '#999' }">{{ member.name }}</span>
            <span v-if="member.stage !== 'READY' && !member.locked" style="font-size:11px; color:#f59e0b; margin-left:auto;">{{ $vuetify.t('$vuetify.groupOrder.participantWaiting') }}</span>
            <span v-else-if="member.stage !== 'READY' && member.locked" style="font-size:11px; color:#888; margin-left:auto;">{{ $vuetify.t('$vuetify.groupOrder.memberLocked') }}</span>
          </div>
        </div>

        <button class="go-ready-btn go-checkout-confirm-btn" :disabled="goCheckoutLoading" @click="goHostCheckout">
          {{ goCheckoutLoading ? $vuetify.t('$vuetify.groupOrder.checkoutProcessing') : $vuetify.t('$vuetify.groupOrder.goToCheckout') }}
        </button>
        <button class="go-remove-cancel-btn go-checkout-back-btn" @click="showCheckoutConfirm = false">{{ $vuetify.t('$vuetify.groupOrder.checkoutBackBtn') }}</button>
      </div>
    </div>

    <!-- <powered-by class="poweredBy" /> -->
  </div>
</template>

<script>
import Login from '@/components/Auth/Login';
import OrderTypeSelect from '@/components/OrderTypeSelect'
import PoweredBy from '@/components/PoweredBy'
import { get, isEmpty } from 'lodash';
import { extractInvalidRulesFromCoupon, isCouponValid, enableDocumentScrolling, getDisplayLocale } from "@/services/util.service"

import { EventBus } from "@/services/event-bus"
import { formatDiscountCap } from "@/services/currency.service"

import { mapMutations, mapActions, mapGetters } from 'vuex';
import CommonPrice from "./Common/CommonPrice"
import PunchCard from "./Common/PunchCard"
import PunchCardDetail from './Common/PunchCardDetail.vue'
import CouponCard from './Coupons/CouponCard'
import RewardOptionsCard from "./RewardsOptions/RewardOptionsCard"

import CartMenuItemDisplay from './CartMenuItemDisplay'
import AiRecommendationsRow from './AiRecommendationsRow'
import { AI_CART_RECOMMENDATIONS_TO_SHOW } from '@/stores/modules/menu'

import { localMenuItemSubtotal, checkLocation, isTimeStale, endSentence } from "@/services/util.service"
import { load as loadRecaptcha } from 'recaptcha-v3'
import OrderTypeSelector from './OrderTypeSelector.vue';
import RewardOptionsCardDetail from './RewardsOptions/RewardOptionsCardDetail.vue';
import CouponCardDetail from './Coupons/CouponCardDetail.vue';

export default {
  name: 'cart',
  components: {
    CommonPrice,
    PunchCard,
    PunchCardDetail,
    CouponCard,
    CouponCardDetail,
    RewardOptionsCard,
    RewardOptionsCardDetail,
    Login,
    OrderTypeSelect,
    PoweredBy,
    CartMenuItemDisplay,
    OrderTypeSelector,
    AiRecommendationsRow
  },

  data() {
    return {
      orderType: '',
      itemDialog: false,
      location: false,
      notInStoreDlg: false,
      isTakeout: false,
      isCheckingOut: false,
      goRemoveCartsLoading: false,
      groupOrderSession: null,
      showCancelGroupConfirm: false,
      cancelGroupLoading: false,
      showLeaveGroupConfirm: false,
      leaveGroupLoading: false,
      showGoMenu: false,
      showInvitePanel: false,
      goCopied: false,
      removeConfirmMember: null,
      showRemoveConfirm: false,
      showCheckoutConfirm: false,
      showStaleScheduleDialog: false,
      scOrderedExpanded: false,
      scFireLoading: false
    }
  },

  computed: {
    // A guest's own cart error banner/ready-gate must only reflect THEIR item-level
    // errors (out-of-stock, disabled item) -- not cartErrorMessage's ORDER-level minimum
    // (doesCartMeetOrderMinimum, group-total-aware), which is the host's concern via
    // blockCheckout. minimumOrderValueInCents was never meant to apply per-participant.
    displayedCartErrorMessage() {
      if (this.groupOrderSession && this.groupOrderSession.role !== 'host')
        return this.$store.getters['groupOrder/cartValidationErrors']
      return this.cartErrorMessage
    },
    goTotalItemCount() {
      const myItems = this.$store.getters['groupOrder/myCartItems'] || [];
      const members = (this.groupOrderSession && this.groupOrderSession.members) || [];
      const memberItems = members.reduce(function(sum, m) { return sum + (m.items ? m.items.length : 0); }, 0);
      return myItems.length + memberItems;
    },
    goNotReadyCount() {
      return this.goUnreadyMembers.length;
    },
    // Members still adding items or who joined with nothing added -- locked members
    // (countdown expired) are treated as ready for checkout. Never includes the host.
    goUnreadyMembers() {
      const members = this.groupOrderSession && this.groupOrderSession.members;
      if (!members) return [];
      return members.filter(function(m) { return m.stage !== 'READY' && !m.locked; });
    },
    // "Pa is still ordering" (1 guest) / "7 guests are still ordering" (2+)
    goUnreadyConfirmTitle() {
      const members = this.goUnreadyMembers;
      if (members.length === 1) {
        return this.$vuetify.t('$vuetify.groupOrder.unreadyConfirmTitleSingle', members[0].name);
      }
      return this.$vuetify.t('$vuetify.groupOrder.unreadyConfirmTitleMulti', members.length);
    },
    // Bold names line, e.g. "Pa and Maya" (2) / "Pa, Maya and 5 others" (3+). Not shown at all for 1 guest.
    goUnreadyNamesText() {
      const names = this.goUnreadyMembers.map(function(m) { return m.name; });
      if (names.length <= 2) {
        return names.join(' ' + this.$vuetify.t('$vuetify.groupOrder.and') + ' ');
      }
      return names.slice(0, 2).join(', ') + ' ' + this.$vuetify.t('$vuetify.groupOrder.andOthers', names.length - 2);
    },
    cartIsLoadingOrLocked() {
      // For hosts, only lock during active checkout processing — not when their cart stage is READY
      // For guests, lock when their cart is locked (marked ready)
      const isHost = !!(this.groupOrderSession && this.groupOrderSession.role === 'host');
      const groupLocked = !!(this.groupOrderSession && this.groupOrderSession.locked && !isHost);
      return this.cartIsLoading || groupLocked || (isHost && this.goCheckoutLoading);
    },
    goDeliverToText() {
      if (this.isPickUp) {
        return (this.getStore && this.getStore.name) || 'Not set';
      }
      if (!this.getDeliveryAddress) return 'Not set';
      const { addressLine1, city, province } = this.getDeliveryAddress;
      if (!addressLine1) return 'Not set';
      return [addressLine1, city, province].filter(Boolean).join(', ');
    },
    goScheduledText() {
      const scheduledTime = this.$store.state.groupOrder && this.$store.state.groupOrder.group && this.$store.state.groupOrder.group.scheduledTime;
      if (!scheduledTime || scheduledTime === 'now') {
        const scheduledDay = this.$store.getters.getCheckoutInfo && this.$store.getters.getCheckoutInfo.scheduledDay;
        if (scheduledDay && scheduledDay !== 'now') {
          const d = new Date(scheduledDay);
          if (!Number.isNaN(d.getTime())) {
            return d.toLocaleDateString(getDisplayLocale(this.$vuetify.lang.current), { month: 'short', day: 'numeric' }) + ', ' + this.$vuetify.t('$vuetify.groupOrder.asap');
          }
        }
        return this.$vuetify.t('$vuetify.groupOrder.asap');
      }
      const d = new Date(scheduledTime);
      if (Number.isNaN(d.getTime())) return this.$vuetify.t('$vuetify.groupOrder.asap');
      const tz = (this.getStore && this.getStore.timeZone) || 'America/Toronto';
      return d.toLocaleDateString(getDisplayLocale(this.$vuetify.lang.current), { weekday: 'short', month: 'short', day: 'numeric', timeZone: tz })
        + ' at '
        + d.toLocaleTimeString(getDisplayLocale(this.$vuetify.lang.current), { hour: 'numeric', minute: '2-digit', timeZone: tz });
    },
    isHostInGroupOrder() {
      return !!(this.$store.state.groupOrder && this.$store.state.groupOrder.isHost);
    },
    goCheckoutEligible() {
      return this.$store.state.groupOrder && this.$store.state.groupOrder.checkoutEligible;
    },
    goCheckoutLoading() {
      return this.$store.state.groupOrder && this.$store.state.groupOrder.checkoutStatus === 'processing';
    },
    goPaymentText() {
      if (!this.groupOrderSession) return '';
      const limit = this.groupOrderSession.limit;
      const isHost = this.$store.state.groupOrder.isHost;
      const who = isHost
        ? this.$vuetify.t('$vuetify.groupOrder.youPayForEveryone')
        : this.$vuetify.t('$vuetify.groupOrder.hostWillPayForEveryone');
      return limit ? `${who} · ${this.$currency(limit, true, true)} limit` : who;
    },
    goDeadlineText() {
      if (!this.groupOrderSession) return '';
      const { deadlineDate, deadlineTime } = this.groupOrderSession;
      if (!deadlineDate) return '';
      const d = new Date(deadlineDate);
      if (Number.isNaN(d.getTime())) return '';
      const tz = (this.getStore && this.getStore.timeZone) || 'America/Toronto';
      let text = d.toLocaleDateString(getDisplayLocale(this.$vuetify.lang.current), { weekday: 'short', month: 'short', day: 'numeric', timeZone: tz });
      if (deadlineTime) {
        const t = new Date(deadlineTime);
        if (!Number.isNaN(t.getTime())) {
          text += ', ' + t.toLocaleTimeString(getDisplayLocale(this.$vuetify.lang.current), { hour: 'numeric', minute: '2-digit', hour12: true, timeZone: tz });
        }
      }
      return text;
    },
    goInviteLink() {
      return this.$store.getters['groupOrder/inviteLink'] || '';
    },
    goQrUrl() {
      const encoded = encodeURIComponent(this.goInviteLink);
      return `https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${encoded}`;
    },
    hasFreeDeliveryCoupon() {
      const activeCodes = this.getActiveCoupon.map(c => c && c.code).filter(Boolean);
      return (this.getPromotions || []).some(p => p.freeDelivery && activeCodes.includes(p.code));
    },
    hasActiveCouponOrderItem() {
      return this.getActiveCoupon.some(coupon => coupon && coupon.orderItem);
    },
    shouldShowStartShoppingButton() {
      const hasAnyCoupon = this.getActiveCoupon.length > 0;
      if (hasAnyCoupon) {
        return false;
      }
      // rewardOptions only actually renders (as promo cards) when not in a shared
      // cart — see cart-promotions-container's `!isSharedCartActive` guard — so a
      // non-empty browsable-rewards catalog must not block this button there too.
      return (
        (this.isSharedCartActive || !this.rewardOptions.length) &&
        (!this.getOrderItemList || !this.getOrderItemList.length) &&
        (!this.getLocalCart.length && !this.getExistingOrder.length)
      );
    },
    isDineInOnlyRoute() {
      return !!this.$route.query.dineInOnly;
    },

    hasTableId() {
      return !!this.$route.query.tid;
    },

    displayableCoupons() {
      if (!this.getAllCartCoupons) return [];

      return this.getAllCartCoupons.filter(coupon => {
        if (!this.getActiveCoupon || !this.getActiveCoupon.length) {
          return true;
        }
        if (!this.hasActiveCouponOrderItem) {
          return true;
        }
        return !this.getActiveCoupon.some(ac => ac && ac.code === coupon.code);
      });
    },
    hasDisplayableCoupons() {
      return this.displayableCoupons && this.displayableCoupons.length > 0;
    },
    // The backend flags the coupon whose cap clamped the discount, so no recalculation here.
    cappedDiscountText() {
      const capped = (this.getAllCartCoupons || []).find(coupon => coupon.discountCapped);
      if (!capped) return null;
      const cap = formatDiscountCap(capped.maxDiscountAmount, this.getCurrencyCode);
      return cap ? this.$vuetify.t('$vuetify.account.rewards.maxDiscountReached', cap) : null;
    },
    ...mapGetters([
      'storeIsAvailable',
      'storeIsOpen',
      'canOrderOffHours',
      'testDateAgainstHours',
      'canOrderOffHours',
      'doesLocalCartHaveErrors',
      'getAllCartCoupons',
      'getCurrencyCode',
      'hasAnyCouponAppliedToCart',
      'hasValidCouponAppliedToCart',
      'getServiceCharges',
      'sumLocalMenuItem',
      'getDeliveryAddress',
      'getStoreDeliveryProvider',
      'isDineInTableSet',
      'getTableDisplay',
      'isDineIn',
      'isDelivery',
      'isPickUp',
      'getOrderTypeObject',
      'getLocalCart',
      'getServerCart',
      'getServerCartItems',
      'getStore',
      'getPickupDeliveryEditDialog',
      'isLoggedIn',
      'isCartLoading',
      'isSelectedGuestLogin',
      // 'getConfigItem',
      'getStoreOrderTypes',
      'isStoreClosed',
      'isDineInSingleOrder',
      'getExistingOrder',
      'getSubOrderId',
      'skipCheckout',

      'inFastServiceDineIn',
      'isLoading',
      'isInStore',
      'getTableId',
      'getDeliveryMin',
      'doesCartMeetDeliveryMinimum',
      'getPickupMin',
      'doesCartMeetPickupMinimum',
      'currentOrderTypeAllowed',
      'getCustomerRewards',
      'getServerPunchCards',
      'getActiveCoupon',
      'getCouponErrors',
      'doesStoreHaveSetting',
      'getRewards',
      'getPunchCards',

      'hasOrder',
      'blockCheckout',
      'cartErrorMessage',
      'deliveryMinMsg',
      'getCheckoutInfo',
      'getMenu',
      'findFullItem',
      'getPromotions',
      'getAiCartRecommendations',
      'getOrderType'
    ]),

    // Identity of "what's in the cart" for the watcher below -- just the codes, so a
    // quantity change or an unrelated cart-object replacement doesn't re-trigger a fetch.
    aiCartRecommendationsCartKey() {
      return (this.getServerCartItems || []).map(item => item.code).filter(Boolean).sort().join(',')
    },
    showAiCartRecommendations() {
      // Hidden outright when the store flag is off -- never an error or empty state.
      // Own store flag (DEV-11147), independent of aiRecommendationCategoryEnabled.
      if (!get(this.getStore, 'settings.owaSettings.aiRecommendationCartEnabled', false)) return false
      // ponytail: group/shared carts add through their own mutateCart paths and aren't
      // part of this ticket's scope -- hide there rather than offer an add that would
      // need a second code path. Enable when the AC covers those surfaces.
      if (this.groupOrderSession || this.isSharedCartActive) return false
      // Shown on an empty cart too -- the picks are what get the guest started. The row
      // itself renders only once it has items (see AiRecommendationsRow), so it can never
      // appear and then vanish while a fetch is in flight.
      return true
    },

    cartIsLoading: {
      set(val) {
        this.SET_CART_LOADING(val)
      },
      get() {
        return !!this.isCartLoading
      }
    },

    isSharedCartActive() {
      return this.$store.getters['sharedCart/isActive']
    },
    sharedCartHasDraftItems() {
      const order = this.$store.getters['sharedCart/order']
      if (!order || !order.subOrderList) return false
      return order.subOrderList.some(function(sub) {
        return sub.orderStatus === 'NEW' && sub.orderItemList && sub.orderItemList.length > 0
      })
    },
    sharedCartWsConnected() {
      return this.$store.state.sharedCart && this.$store.state.sharedCart.wsConnected
    },

    getOrderItemList() {
      if (this.$store.getters['groupOrder/isInGroupOrder']) {
        // In group order mode, render from participantCart (source of truth)
        // Map price → itemPrice so CartMenuItemDisplay renders correctly
        // specialRequest lives on the sub-order, attach it to the first item so CartMenuItemDisplay shows it
        return (this.$store.getters['groupOrder/myCartItems'] || []).map(function(item) {
          return Object.assign({}, item, { itemPrice: item.itemPrice || item.price || 0 })
        })
      }
      if (this.isSharedCartActive) {
        // A shared-cart order can have multiple subOrders: fired rounds
        // (orderStatus: 'SUBMITTED'), one per "Send to Kitchen" tap, plus at
        // most one current draft (orderStatus: 'NEW'). Flatten all of them,
        // tagging each item with which round it belongs to (seq + when it was
        // fired) so the template can group rounds separately and lock
        // already-sent items instead of showing one undifferentiated bucket.
        const subOrders = get(this.getServerCart, 'subOrderList', [])
        return subOrders.reduce(function(items, subOrder) {
          // NEW is the only pre-fire status (the current draft). Everything else --
          // SUBMITTED, IN_PROCESS, ACCEPTED, READY, COMPLETED -- is a round that's
          // already left the draft and been sent to the kitchen; the sub-order
          // advances through those as the kitchen/POS processes it, so checking
          // for SUBMITTED alone stopped matching the moment a round moved past
          // that first status (see SUB_ORDER_STATUS in OrderEnums.java).
          // CANCELLED items are excluded entirely below via item.status.
          const sent = subOrder.orderStatus !== 'NEW'
          const taggedItems = (subOrder.orderItemList || []).map(function(item) {
            return Object.assign({}, item, {
              _scSent: sent,
              _scRoundSeq: subOrder.seq,
              _scRoundCreateTime: subOrder.createTime
            })
          })
          return items.concat(taggedItems)
        }, [])
      }
      return get(this.getServerCart, 'subOrderList[0].orderItemList', [])
    },

    // "Already ordered" rounds, grouped for the collapsible panel -- one entry
    // per fired sub-order, each carrying its own items so the template doesn't
    // need to re-scan getOrderItemList to find a round's boundaries.
    scOrderedRounds() {
      if (!this.isSharedCartActive) return []
      const groups = []
      let current = null
      this.getOrderItemList.forEach(function(item) {
        if (!item._scSent) return
        if (!current || current.seq !== item._scRoundSeq) {
          current = { seq: item._scRoundSeq, createTime: item._scRoundCreateTime, items: [] }
          groups.push(current)
        }
        current.items.push(item)
      })
      return groups
    },
    scDraftItems() {
      if (!this.isSharedCartActive) return []
      return this.getOrderItemList.filter(function(item) { return !item._scSent })
    },

    serverCoupons() {
      if (this.$store.getters['groupOrder/isInGroupOrder']) {
        return get(this.$store.state.groupOrder, 'participantCart.subOrderList[0].coupons', [])
      }
      return get(this.getServerCart, 'subOrderList[0].coupons', [])
    },
    hasAppliedReward() {
      // rewardOptions() falls back to the full browsable rewards catalog when
      // there's no order to redeem against yet — that's correct for the promo
      // panel (showing "you could redeem these") but must never be read as
      // "there's something to check out." Only a reward actually redeemed
      // against the current order (redemptionItems on the live subOrder)
      // means there's something in progress.
      return !!get(this.getServerCart, 'subOrderList[0].redemptionItems', []).length
    },
    rewardOptions() {
      if (this.$store.getters['groupOrder/isInGroupOrder']) return []
      if (this.getRewards && this.getRewards.redeemOptions) {
        const allRewards = get(this.getRewards, 'redeemOptions', [])
        if (this.getServerCart && this.getServerCart.subOrderList && this.getServerCart.subOrderList.length) {
          const subOrder = get(this.getServerCart, 'subOrderList[0]', {});
          const redemptionItems = get(subOrder, 'redemptionItems', []).map(_reward => ({
            ...(allRewards.find(_r => _r.rewardName === _reward.name) || {}),
            ..._reward
          }));

          const coupons = get(subOrder, 'coupons', []).map(coupon => ({
            ...coupon,
            type: 'coupon'
          }));
          return [...redemptionItems, ...coupons];
        } else {
          return get(this.getRewards, 'redeemOptions', [])
        }
      } else {
        return []
      }
      // return get(this.getRewards, 'redeemOptions', [])
    },

    cartTitle() {
      const orderType  = this.getOrderTypeObject
      const i18nString = get(orderType, 'i18n', '')
      const name = this.$vuetify.t(i18nString)
      const tableId = this.getTableId
      const tableDisplay = this.getTableDisplay

      let displayText = this.isDineIn && this.isDineInTableSet
        ? `${name} (Table #${tableDisplay})`
        : name

      // Hard coding table for specific customer for specific use case
      if (tableId === '989898') {
        displayText =  this.$vuetify.t('$vuetify.common.takeout')
      }

      return displayText
    },
    canCheckout() {
      if (this.hasOrder())
        return false

      if (this.getExistingOrder.length) {
        let submitted = _.find(this.getExistingOrder, {orderStatus:'SUBMITTED'})
        let cancelled = this.getExistingOrder.map(i => {
          if (i.orderStatus === 'CANCELLED') {
            return i.orderStatus
          }
        }).filter(Boolean)

        let allCancelled = this.getExistingOrder.length === cancelled.length

        if (submitted || allCancelled) {
          return false
        } else {
          return this.getLocalCart.length === 0
        }
      } else {
        if(this.rewardOptions && this.rewardOptions.length) {
          return true
        }
      }
    },
    isVisible() {
      const loggedAndOpen = this.isLoggedIn // && !this.isStoreClosed

      if (loggedAndOpen && !this.isDineIn) {
        return true
      }

      if (loggedAndOpen && this.isDineInSingleOrder && !this.skipCheckout) {
        return true
      } else {
        return false
      }

      if (loggedAndOpen && !this.isDineInSingleOrder && this.canCheckout && !this.skipCheckout) {
        return true
      } else {
        return false
      }
    },
    shouldSkipCheckout() {
      return this.isLoggedIn && !this.isStoreClosed && this.skipCheckout
    },
    allowAnonymous() {
      return get(this.getStore, 'settings.owaSettings.allowAnonymousDineInOrder', false) && this.isSelectedGuestLogin;
    },
    // checkoutState() {
    //   return (!this.getStore.settings.owaSettings.deliveryEnabled && this.isDelivery) ||
    //          (!this.getStore.settings.owaSettings.pickupEnabled && this.isPickUp)
    // },

    showTaxDetail() {
      return get(this.getStore, 'settings.orderSettings.showTaxDetail', false)
    },
    showTakeout() {
      return get(this.getStore, 'settings.orderSettings.allowTakeoutOnDineIn', false)
    },
    multiIsReadyToPay() {
      return true
    },

    orderNotes: {
      get() {
        return get(this.getCheckoutInfo, 'orderNotes', '')
      },
      set(value) {
        this.SET_CHECKOUT_INFO({
          ...this.getCheckoutInfo,
          orderNotes: value
        })
      }
    }
  },
  mounted() {
    this.$bus.$on('guestCheckoutRequested', this.handleGuestCheckout);
    // checkStale: true -- the cart panel just opened, a real trigger for revalidating
    // the schedule (see loadGroupOrderSession's own comment for why this must be opt-in).
    this.loadGroupOrderSession(true);
    // Wrapped, not passed directly: addEventListener calls its handler with the native
    // Event object as the first argument, which is truthy -- passing
    // loadGroupOrderSession directly would silently turn its checkStale default on for
    // every groupOrderSessionUpdated broadcast (fired on essentially every group-order
    // action via goSaveSession), defeating the whole point of making it opt-in.
    this._onGroupOrderSessionUpdated = () => this.loadGroupOrderSession();
    window.addEventListener('groupOrderSessionUpdated', this._onGroupOrderSessionUpdated);
  },

  beforeDestroy() {
    this.$bus.$off('guestCheckoutRequested', this.handleGuestCheckout);
    window.removeEventListener('groupOrderSessionUpdated', this._onGroupOrderSessionUpdated);
  },
  methods: {
    isSharedCartItemStale(uuid) {
      return this.$store.getters['sharedCart/isItemStale'](uuid)
    },
    // Round header timestamp -- e.g. "2:14 PM". Shows in the guest's own local
    // time (same convention as every other on-device clock in this app); the
    // round's actual kitchen-side time is a POS/KDS concern, not this display.
    formatSharedCartRoundTime(createTime) {
      if (!createTime) return ''
      var d = new Date(createTime)
      if (isNaN(d.getTime())) return ''
      return d.toLocaleTimeString(undefined, { hour: 'numeric', minute: '2-digit' })
    },
    // Session-closed is always shown with our own translated copy — the
    // backend's errorMsg for it ("Shared cart session is closed") is a plain
    // English literal, not localized, so showing it as-is would be
    // untranslated text for every non-English guest. Any other error still
    // prefers the backend's errorMsg (more specific than our generic
    // fallback) since we can't pre-translate messages we don't know about.
    sharedCartErrorText(e, fallbackKey) {
      const errorCode = e && e.response && e.response.data && e.response.data.errorCode
      if (errorCode === 'SHARED_CART_SESSION_CLOSED') {
        return this.$vuetify.t('$vuetify.sharedCart.errorSessionClosed')
      }
      const backendMsg = e && e.response && e.response.data && e.response.data.errorMsg
      return backendMsg ? endSentence(backendMsg) : this.$vuetify.t(fallbackKey)
    },
    async scFireRound() {
      if (this.scFireLoading) return
      this.scFireLoading = true
      try {
        await this.$store.dispatch('sharedCart/submitRound', {})
      } catch (e) {
        const msg = this.sharedCartErrorText(e, '$vuetify.sharedCart.errorFireRound')
        this.$store.dispatch('showSnack', { text: msg, color: 'error', timeout: 4000 })
      } finally {
        this.scFireLoading = false
      }
    },
    // Called by the parent when the cart dialog closes (v-dialog keeps this component
    // mounted, not destroyed) -- clears every confirm dialog's open flag so a stale one
    // doesn't reappear the next time the cart is opened.
    resetTransientDialogs() {
      this.showCancelGroupConfirm = false;
      this.showLeaveGroupConfirm = false;
      this.showRemoveConfirm = false;
      this.showCheckoutConfirm = false;
    },
    // checkStale: whether to also revalidate the schedule after syncing. Defaults to
    // false -- this method is called constantly as a passive re-sync (the deep watchers
    // on participantCart/participantCarts/group, the websocket-driven group-state
    // refetch on ANY participant's CART_CHANGED event, goSaveSession's
    // groupOrderSessionUpdated broadcast), not just when the host is actually about to
    // act on their schedule. DEV-10876: a guest simply adding an item to their own cart
    // was popping the "time no longer available" dialog on the HOST's browser, because
    // that guest's CART_CHANGED event reaches the host too (group-order-ws.service.js),
    // refetches group state, and used to trigger this same unconditional check as a side
    // effect. checkStaleScheduledTime must only run on a real trigger -- the cart panel
    // opening (mounted) or the host explicitly going to checkout (goHostCheckout, which
    // already calls it directly) -- never as a passive reaction to someone else's cart.
    loadGroupOrderSession(checkStale = false) {
      // Primary: read from Vuex groupOrder module (real API or mock, same shape)
      const vuexSession = this.$store.getters['groupOrder/legacyGroupOrderSession'];
      if (vuexSession) {
        this.groupOrderSession = vuexSession;
        if (checkStale) this.checkStaleScheduledTime();
        return;
      }
      // Fallback: old raw localStorage format (for sessions started before this migration)
      try {
        const session = JSON.parse(localStorage.getItem('groupOrderSession')) || null;
        this.groupOrderSession = session;
      } catch (e) {
        this.groupOrderSession = null;
      }
    },

    // Runs for the group-order host (checked against the group's scheduledTime) and for
    // solo checkout (checked against the local checkout info) alike -- same "Go to Checkout"
    // trigger requirement applies to both, not just group orders.
    // Uses validTimeSlots off a bill fetch (same source CheckoutPage.vue uses) -- not just
    // "already expired" like before, so this catches the ticket's real bug: time still in
    // the future but inside the prep+delivery buffer. Cart.vue has no cached bill of its
    // own, so this fetches one.
    // Recovery UI is the same day/time picker used everywhere else, opened with a banner
    // explaining why -- not a separate custom modal.
    async checkStaleScheduledTime() {
      if (this.getPickupDeliveryEditDialog) return;
      // Dine-in (including shared cart, which is dine-in-only) never sends
      // scheduledTime to the server -- see fetchShoppingCart's `state.orderType !==
      // 'DINE_IN'` guard in cart.js. checkoutInfo.scheduledTime can still hold a
      // leftover value from before dine-in/shared-cart started (e.g. a scheduled
      // pickup time picked earlier in the session), so without this guard the
      // "time no longer available" dialog could fire for an order type that was
      // never going to use that time in the first place.
      if (this.isDineIn) return;
      // this.groupOrderSession is a local component copy that can lag the store (it's
      // only refreshed by loadGroupOrderSession()) -- isHostInGroupOrder reads
      // $store.state.groupOrder.isHost directly, same source CheckoutPage.vue uses.
      const isInGroupOrder = this.$store.getters['groupOrder/isInGroupOrder'];
      const isGroupHost = this.isHostInGroupOrder;
      // Guests can't change the group's schedule, so there's nothing for them to
      // revalidate -- only the host's scheduledTime (or a solo order's) is checked.
      if (isInGroupOrder && !isGroupHost) return;
      const scheduledTime = isGroupHost
        ? this.$store.state.groupOrder && this.$store.state.groupOrder.group && this.$store.state.groupOrder.group.scheduledTime
        : this.getCheckoutInfo && this.getCheckoutInfo.scheduledTime;
      if (!scheduledTime || scheduledTime === 'now') return;
      // validTimeSlots lives on serverCart (getValidTimeSlots), populated by
      // fetchShoppingCart -- NOT on state.bill (fetchBillView/fetchGroupOrderBillView),
      // which never carries this field. Group orders' bare fetchShoppingCart() no-ops
      // (cart.js's _fetchShoppingCartImpl early-returns for them), so forceTimeSlots is
      // required for both paths to actually hit the API and refresh it.
      await this.fetchShoppingCart({ forceTimeSlots: true }).catch(() => {});
      const validTimeSlots = this.$store.getters.getValidTimeSlots;
      const storeTz = (this.getStore && this.getStore.timeZone) || 'America/Toronto';
      const stale = validTimeSlots && validTimeSlots.day_slots ? isTimeStale(validTimeSlots, scheduledTime, storeTz, isGroupHost) : null;
      if (!validTimeSlots || !validTimeSlots.day_slots) return;
      if (!stale) return;
      // Raw datetime, not a pre-formatted string -- PickupDeliveryEditDialog builds the
      // full "no longer available" sentence itself (date + bolded time, group-vs-solo
      // copy), so every caller just hands over what went stale.
      this.SET_PICKUP_DELIVERY_EDIT_DIALOG_MESSAGE(scheduledTime);
      this.SET_PICKUP_DELIVERY_EDIT_DIALOG(true);
    },

    goSaveSession() {
      // With Vuex-backed state, saving is a no-op for display purposes.
      // Mutations go through groupOrder Vuex actions (mutateCart, readyCart, etc.).
      // The legacy localStorage write is kept only for sessions not yet migrated.
      if (!this.$store.getters['groupOrder/isInGroupOrder']) {
        localStorage.setItem('groupOrderSession', JSON.stringify(this.groupOrderSession));
      }
      window.dispatchEvent(new Event('groupOrderSessionUpdated'));
    },

    async goMarkReady() {
      if (this.$store.getters['groupOrder/isInGroupOrder']) {
        if (this._goMarkReadyInFlight) return;
        // Same reasoning as goOpenCheckoutConfirm's fetch-before-check for the host:
        // displayedCartErrorMessage only reflects whatever group state was last fetched
        // into Vuex, and nothing re-fetches it on its own while a guest just sits on the
        // cart panel. readyCart itself never validates the cart either, so a stale
        // "looks fine" here is the only thing that would let a guest mark ready with an
        // item that's actually gone out of stock. Best-effort: if the fetch itself
        // fails, fall through to whatever's already cached rather than blocking ready
        // on a network hiccup. Uses displayedCartErrorMessage (guest-scoped item-level
        // errors), not cartErrorMessage -- see displayedCartErrorMessage's own comment.
        this._goMarkReadyInFlight = true;
        try {
          await this.$store.dispatch('groupOrder/fetchGroupState');
        } catch (e) { /* best-effort */ }
        finally {
          this._goMarkReadyInFlight = false;
        }
        if (this.displayedCartErrorMessage) {
          this.$store.dispatch('showSnack', { text: this.displayedCartErrorMessage, color: 'error' });
          return;
        }
        try {
          await this.$store.dispatch('groupOrder/readyCart');
          this.loadGroupOrderSession();
        } catch (e) {
          // Fetch latest state — if the host moved to checkout, our cart will now
          // be locked (lockedReason: 'CHECKOUT') and the UI will update accordingly.
          // Only show an error if we're still not locked after the refresh.
          try {
            await this.$store.dispatch('groupOrder/fetchGroupState');
            this.loadGroupOrderSession();
          } catch (_) {}
          const pc = this.$store.state.groupOrder.participantCart;
          if (!pc || !pc.locked) {
            this.$store.dispatch('showSnack', { text: this.$vuetify.t('$vuetify.groupOrder.errorMarkReady'), color: 'error' });
          }
        }
      } else {
        this.groupOrderSession = { ...this.groupOrderSession, myReady: true };
        this.goSaveSession();
      }
    },

    // "Go to Checkout" button in the cart -- check blockCheckout (e.g. below delivery
    // minimum) before opening the confirm dialog at all, instead of only catching it
    // after the host has already picked an action inside the dialog.
    async goOpenCheckoutConfirm() {
      if (this.goCheckoutLoading || this._goOpenCheckoutConfirmInFlight) return;
      // blockCheckout (anyParticipantCartHasErrors specifically) only reflects whatever
      // group state was last fetched -- a guest's item can go out of stock at any time,
      // and nothing re-fetches group state on its own while the host just sits on the
      // cart panel (only a mount, a mid change, or the host's own mutation does). Refresh
      // right before checking, so this can't open on a guest error that happened after the
      // last fetch. Best-effort: if the fetch itself fails, fall through to whatever
      // blockCheckout already reads rather than blocking checkout on a network hiccup.
      this._goOpenCheckoutConfirmInFlight = true;
      try {
        await this.$store.dispatch('groupOrder/fetchGroupState');
      } catch (e) { /* best-effort */ }
      finally {
        this._goOpenCheckoutConfirmInFlight = false;
      }
      if (this.blockCheckout) {
        this.$store.dispatch('showSnack', { text: this.cartErrorMessage, color: 'error' });
        return;
      }
      this.showCheckoutConfirm = true;
    },

    async goHostCheckout() {
      if (this.goCheckoutLoading || this._goHostCheckoutInFlight) return;
      if (this.blockCheckout) {
        // Close the confirm dialog rather than leaving it open with dead-end buttons --
        // e.g. removing unready carts can empty the group or drop it below the delivery
        // minimum, and there's nothing more to pick from this dialog at that point. The
        // snack still explains why, same as the regular "Go to Checkout" entry point
        // (goOpenCheckoutConfirm) already does before ever opening this dialog.
        this.showCheckoutConfirm = false;
        this.$store.dispatch('showSnack', { text: this.cartErrorMessage, color: 'error' });
        return;
      }
      this.showCheckoutConfirm = false;
      // Revalidate before leaving the cart -- CheckoutPage.vue re-checks on mount too,
      // but doing it here means the host sees the prompt right on "Go to Checkout"
      // instead of after a page navigation, per the ticket's trigger requirement.
      // goCheckoutLoading doesn't cover this fetch (that flag only tracks payment
      // submission), so guard re-entrancy locally to stop a double-click firing twice.
      this._goHostCheckoutInFlight = true;
      try {
        await this.checkStaleScheduledTime();
      } finally {
        this._goHostCheckoutInFlight = false;
      }
      if (this.getPickupDeliveryEditDialog) return;
      try {
        // Navigate to normal checkout page — payment is handled there
        // The router afterEach hook auto-locks the host cart on arrival at checkout
        sessionStorage.setItem('groupOrderCheckoutBackPath', this.$route.fullPath);
        this.$emit('closeCart');
        this.$router.push({
          name: 'checkout',
          params: {
            gid: this.getStore.groupId,
            sid: this.getStore.storeId
          },
          query: { ...this.$route.query }
        }).catch(function() {});
      } catch (e) {
        const msg = this.$vuetify.t('$vuetify.groupOrder.errorLockGroup');
        this.$store.dispatch('showSnack', { text: msg, color: 'error' });
      }
    },

    async goRemoveUnreadyAndCheckout() {
      if (this.goCheckoutLoading || this.goRemoveCartsLoading) return;
      const targetOrderIds = this.goUnreadyMembers.map(function(m) { return m.orderId; }).filter(Boolean);
      if (!targetOrderIds.length) {
        return this.goHostCheckout();
      }
      this.goRemoveCartsLoading = true;
      try {
        await this.$store.dispatch('groupOrder/removeParticipants', { participantOrderIds: targetOrderIds });
      } catch (e) {
        // Some carts may have been removed before the failure -- refresh so the cart panel
        // (the roster/source of truth per the design) reflects whatever partially succeeded.
        this.loadGroupOrderSession();
        this.$store.dispatch('showSnack', { text: this.$vuetify.t('$vuetify.groupOrder.errorRemoveUnreadyCarts'), color: 'error' });
        return;
      } finally {
        this.goRemoveCartsLoading = false;
      }
      this.loadGroupOrderSession();
      await this.goHostCheckout();
    },

    goOpenInviteDialog() {
      EventBus.$emit('openGroupOrderInvite');
    },

    goOpenDeadlineDialog() {
      EventBus.$emit('openGroupOrderDeadline');
    },

    async goConfirmLeaveGroup() {
      this.leaveGroupLoading = true;
      try {
        await this.$store.dispatch('groupOrder/leaveGroup');
      } finally {
        this.leaveGroupLoading = false;
        this.showLeaveGroupConfirm = false;
        this.$emit('closeCart');
      }
    },

    async goConfirmCancelGroup() {
      this.cancelGroupLoading = true;
      try {
        await this.$store.dispatch('groupOrder/cancelGroup');
        this.showCancelGroupConfirm = false;
        this.$emit('closeCart');
      } catch (e) {
        this.$store.dispatch('showSnack', { text: this.$vuetify.t('$vuetify.groupOrder.errorCancelGroup'), color: 'error' });
      } finally {
        this.cancelGroupLoading = false;
      }
    },

    async goUnlockMember(member) {
      if (!member || !member.orderId) return;
      try {
        await this.$store.dispatch('groupOrder/unlockCart', { targetCartOrderId: member.orderId });
        this.loadGroupOrderSession();
      } catch (e) {
        this.$store.dispatch('showSnack', { text: this.$vuetify.t('$vuetify.groupOrder.errorUnlockMember'), color: 'error' });
      }
    },

    goRemoveMember(midx) {
      const members = this.groupOrderSession.members || [];
      const member = members[midx];
      if (!member) return;
      this.removeConfirmMember = { midx, name: member.name, orderId: member.orderId };
      this.showRemoveConfirm = true;
    },

    async goConfirmRemove() {
      if (!this.removeConfirmMember) return;
      const targetCartOrderId = this.removeConfirmMember.orderId;

      if (!targetCartOrderId) {
        this.$store.dispatch('showSnack', { text: 'Could not identify participant to remove.', color: 'error' });
        this.removeConfirmMember = null;
        this.showRemoveConfirm = false;
        return;
      }

      try {
        await this.$store.dispatch('groupOrder/removeParticipant', { targetCartOrderId });
        this.loadGroupOrderSession();
      } catch (e) {
        this.$store.dispatch('showSnack', { text: this.$vuetify.t('$vuetify.groupOrder.errorRemoveParticipant'), color: 'error' });
      }
      this.removeConfirmMember = null;
      this.showRemoveConfirm = false;
    },

    goIncrementMemberItem(midx, iidx) {
      // Host item qty changes on guest carts are not supported via this UI path.
      // This is a display-only action in the real API (host can only REMOVE from guest carts).
      if (!this.$store.getters['groupOrder/isInGroupOrder']) {
        const members = JSON.parse(JSON.stringify(this.groupOrderSession.members));
        members[midx].items[iidx].qty = (members[midx].items[iidx].qty || 1) + 1;
        this.groupOrderSession = { ...this.groupOrderSession, members };
        this.goSaveSession();
      }
    },

    goDecrementMemberItem(midx, iidx) {
      if (!this.$store.getters['groupOrder/isInGroupOrder']) {
        const members = JSON.parse(JSON.stringify(this.groupOrderSession.members));
        const qty = (members[midx].items[iidx].qty || 1) - 1;
        if (qty <= 0) members[midx].items.splice(iidx, 1);
        else members[midx].items[iidx].qty = qty;
        this.groupOrderSession = { ...this.groupOrderSession, members };
        this.goSaveSession();
      }
    },

    async handleGuestCheckout() {
      try {
        await this.payOrderSkip('replace');
        this.$bus.$emit('guestCheckoutSuccess');
        await this.$nextTick();
        this.cartDialog = false;
      } catch (error) {
        this.$bus.$emit('guestCheckoutError', error);
      }
    },

    isQuantityBasedPromotion(item) {
      const fullMenuItem = this.findFullItem(item)
      
      if (fullMenuItem && fullMenuItem.relations && fullMenuItem.relations.length > 0) {
        const hasQuantityRule = fullMenuItem.relations.some(relation => 
          relation.charge && relation.charge.quantityRule
        )
        return hasQuantityRule
      }
      return false
    },

    getOriginalPriceForItem(item) {
      const fullMenuItem = this.findFullItem(item);
      if (!fullMenuItem) return item.itemPrice || 0;

      if (fullMenuItem.unitPrice) {
        return fullMenuItem.unitPrice;
      }
      
      if (item && item.childItemList && item.childItemList.length > 0) {
        for (const child of item.childItemList) {
          if (child.relation && child.unitPrice) {
            return child.unitPrice;
          }
        }
      }
      
      return item.itemPrice || 0;
    },
    ...mapActions([
      'setCouponCode',
      'removeFromCart',
      'fetchShoppingCart',
      'incrementCart',
      'decrementCart',
      'setOrderType',
      // 'setCartEditItem',
      // 'setRawData',
      'setExistingOrder',
      'updateSubOrder',
      'createSubOrder',
      'prepNextOrder',
      'payOrder',
      'openWeChatDialog',
      'setInStore',
      'setPaymentType',
      'removeCoupon',
      'resetCart',
      'fetchAiCartRecommendations'
    ]),
    ...mapMutations([ 'setLoginDialog', 'SET_PAYMENT_TYPE', 'SET_ACTIVE_COUPON', 'SET_CART_LOADING', 'SET_CHECKOUT_INFO', 'SET_PICKUP_DELIVERY_EDIT_DIALOG', 'SET_PICKUP_DELIVERY_EDIT_DIALOG_MESSAGE' ]),

    closeCartAndEnableScrolling() {
      this.$emit('closeCart')

      if (this.$vuetify.breakpoint.smAndDown) {
        enableDocumentScrolling();
      }
    },

    _isCouponValid: val => isCouponValid(val),
    doesItemHaveErrors(item) {
      return Array.isArray(item.errors) && (item.errors.length > 0)
    },
    isDisableSpecialRequest() {
      return get(this.getStore, 'settings.orderSettings.disableSpecialRequestforItem', false)
    },
    getItemErrors(item) {
      return get(item, 'errors', []).map(error => Object.assign({}, error, { errorMsg: endSentence(error.errorMsg) }))
    },
    memberHasErrors(member) {
      return (member.items || []).some(this.doesItemHaveErrors)
    },
    onRemoveCoupon() {
      if (this.$store.getters['groupOrder/isInGroupOrder']) {
        this.$store.dispatch('groupOrder/removeCoupon')
          .then(() => this.$store.dispatch('groupOrder/fetchGroupState'))
          .catch((e) => console.error('[onRemoveCoupon]', e))
      } else {
        this.removeCoupon()
        this.fetchShoppingCart()
      }
    },
    getInvalidRules(coupon) {
      const invalidRules = extractInvalidRulesFromCoupon(coupon)

      return invalidRules
    },
    showDiscountLine() {
      return +this.getServerCart.discountTotal < 0// && this.hasAnyCouponAppliedToCart
    },
    multiIsVisible(checkoutState) {
      const loggedAndOpen = this.isLoggedIn && !this.isStoreClosed

      return this.isLoggedIn && !this.isStoreClosed && !this.isDineInSingleOrder && this.isDineIn// && checkoutState
    },
    isDeliveryAddressSet() {
      return !this.isDelivery || !isEmpty(this.getDeliveryAddress)
    },
    orderHistory() {
      this.$router.push({name: 'orderHistory'}).catch(() => {})
    },
    // Is this used?
    isCartItem(index) {
      return {
        isCartItem: true,
        index
      }
    },
    fetchConfigItems(item) {
      let configItems = []
      item.itemAttributeList.map(option => {
        option.attrValueList.forEach(opt => {
          configItems.push(opt)
        })
      })

      return configItems.filter(Boolean)
    },
    fetchConfigItemsSubOrder(item){
      let configItems = []
      if(item.itemAttributeList){
        item.itemAttributeList.map(option => {
          option.attrValueList.forEach(opt => {
            configItems.push(opt)
          })
        })
      }
      return configItems.filter(Boolean)
    },
    getConfigPrice(item) {
      const price = get(item, 'charges[0].price', '')
      // const qty = get(item, 'qty', 1) || 1
      //
      // return price * qty
      return price
    },


    checkForDeliveryAddress() {
      if (!this.isDeliveryAddressSet()) {
        this.$store.dispatch('showSnack', {
          text: this.$vuetify.t('$vuetify.order.deliveryAddressMustBeSet'),
          color: 'error'
        })

        // Global event
        EventBus.$emit('delivery-address-error');
        this.$emit('close-cart')
        return false
      }

      return true
    },

    async payOrderSkip(shouldReplace) {
      // Guard against double-clicks using dedicated checkout flag
      // (cartIsLoading can be true from fetchShoppingCart, which would block checkout)
      if (this.isCheckingOut) return

      const performAction = async () => {
       // The user needs to select a table before being able to finalize their dine in order
        if (this.isDineIn && !this.isDineInTableSet) {
          // Wechat doesn't allow camera, so we instead open the dialog to use manual enter
          if (this.isWeChat()){
            this.openWeChatDialog()
          }else {
            this.$store.dispatch('setQrScanner', true)
          }
        } else {
          const isTakeout = this.isTakeout;
          this.SET_CHECKOUT_INFO({
            ...this.getCheckoutInfo,
            takeout: isTakeout ? true : null
          });
          this.isTakeout = false;
          this.SET_PAYMENT_TYPE('offline')
          await this.payOrder(shouldReplace)
          this.$bus.$emit('guestCheckoutSuccess');
        }
      }

      try {
        // Disable the button to avoid duplicate actions
        this.isCheckingOut = true
        this.cartIsLoading = true

        if (this.getStore.settings.owaSettings.verifyLocation === true && this.isDineIn) {
          await checkLocation()
          if (this.isInStore)
            await performAction()
        } else {
          await performAction()
        }
        return true
      } catch(e) {
        console.log(''+e);

        this.$api.post('/order/error', {
          error: ''+e,
          statusCode: 505,
          storeId: this.getStore.storeId
        })
        throw e;
      } finally {
        this.isCheckingOut = false
        this.cartIsLoading = false;
      }
    },
    closeScroll() {
      if (this.$route.name !== 'store') {
        const mid = (this.getMenu && this.getMenu.code)
          || (this.$store.getters.getAvailableMenus && this.$store.getters.getAvailableMenus[0] && this.$store.getters.getAvailableMenus[0].code);
        this.$router.push({
          name: 'store',
          params: {
            gid: this.getStore.groupId,
            sid: this.getStore.storeId,
            mid: mid,
            restaurantSlug: this.getStore.slug
          },
          query: this.$route.query
        }).then(() => {
          enableDocumentScrolling(false, true);
        }).catch(() => {})
      } else {
        EventBus.$emit('scrollToMenu');
        this.$emit('closeCart');
      }
      return;
    },
    async checkoutAction() {
      // Guard against double-clicks using dedicated checkout flag
      if (this.isCheckingOut) return

      // DEV-7608: Don't close cart if there's an active coupon with orderItem
      if (!this.getLocalCart.length && !this.getExistingOrder.length && !this.rewardOptions.length && !this.hasActiveCouponOrderItem) {
        this.closeScroll()
      }
      if (!this.isLoggedIn) {
        this.setLoginDialog(true)
        return
      }

      // Revalidate before leaving the cart -- CheckoutPage.vue re-checks on mount too,
      // but doing it here means the user sees the prompt right on "Go to Checkout"
      // instead of after a page navigation, per the ticket's trigger requirement.
      await this.checkStaleScheduledTime()
      if (this.getPickupDeliveryEditDialog) return

      const performAction = async () => {
        const isTakeout = this.isTakeout;
        this.SET_CHECKOUT_INFO({
          ...this.getCheckoutInfo,
          takeout: isTakeout ? true : null
        });
        this.isTakeout = false
        const vc = this.$route.query.vc;

        // The user needs to select a table before being able to finalize their dine in order
        if (this.isDineIn && !this.isDineInTableSet && !this.inFastServiceDineIn) {
          // Wechat doesn't allow camera, so we instead open the dialog to use manual enter
          if (this.isWeChat())
            return this.openWeChatDialog()
          else
            return this.$store.dispatch('setQrScanner', true)
        } else if (this.multiIsVisible(!this.canCheckout)) {
          if (this.getExistingOrder.length) {
            if (this.isDineIn && !isTakeout) {
              const tid = this.$route.query['tid'];
              const queryObj = { ...this.$route.query, tid: tid };
              if (vc) queryObj.vc = vc;

              // Close cart before navigating to checkout
              this.closeCartAndEnableScrolling()
              sessionStorage.setItem('groupOrderCheckoutBackPath', this.$route.fullPath)

              this.$router.push({
                name: 'checkout',
                params: {
                  gid: this.getStore.groupId,
                  sid: this.getStore.storeId,
                  tid: tid
                },
                query: queryObj
              }).catch(() => {})
            } else if (!this.hasOrder()) {
              // Close cart before navigating to checkout
              this.closeCartAndEnableScrolling()
              sessionStorage.setItem('groupOrderCheckoutBackPath', this.$route.fullPath)

              this.$router.push({
                name: 'checkout',
                params: {
                  gid: this.getStore.groupId,
                  sid: this.getStore.storeId
                },
                query: {
                   ...this.$route.query,
                  vc
                }
              }).catch(() => {})
            } else {
              return this.updateSubOrder(this.getSubOrderId).then(res => {
                this.prepNextOrder()
                return res
              })
            }
          } else {
            return this.createSubOrder().then(res => {
              this.prepNextOrder()
              return res
            })
          }
        } else if (this.shouldSkipCheckout && this.isDineIn) {
          // 'offline' is a hardcoded special keyword that tells
          // store/cart.payOrder to clear the checkout form object with a blank one
          this.SET_PAYMENT_TYPE('offline')

          // Wait for payment to complete before closing cart
          await this.payOrder('replace')

          // Only close cart after successful payment
          this.closeCartAndEnableScrolling()
        } else if (this.checkForDeliveryAddress()) {
          // Delivery address is only editable on the menu page, so once it and the table are set,
          // if we're not skipping checkout, we can send them there to finalize their order
            if (this.isDineIn && !isTakeout) {
              const tid = this.$route.query['tid'];
              const queryObj = { ...this.$route.query, tid: tid };
              if (vc) queryObj.vc = vc;

              // Close cart before navigating to checkout
              this.closeCartAndEnableScrolling()
              sessionStorage.setItem('groupOrderCheckoutBackPath', this.$route.fullPath)

              this.$router.push({
                name: 'checkout',
                params: {
                  gid: this.getStore.groupId,
                  sid: this.getStore.storeId,
                  tid: tid
                },
                query: queryObj
              }).catch(() => {})
            } else {
              // Close cart before navigating to checkout
              this.closeCartAndEnableScrolling()
              sessionStorage.setItem('groupOrderCheckoutBackPath', this.$route.fullPath)

              this.$router.push({
                name: 'checkout',
                params: {
                  gid: this.getStore.groupId,
                  sid: this.getStore.storeId
                },
                query: {
                   ...this.$route.query,
                  vc
                }
              }).catch(() => {})
            }
        }
      }

      try {
        // Disable the button to avoid duplicate actions
        this.isCheckingOut = true
        this.cartIsLoading = true

        if (this.isDineIn && this.getStore.settings.owaSettings.verifyLocation === true) {
          await checkLocation()
          if (this.isInStore)
            await performAction()
        } else {
          await performAction()
        }

        this.cartIsLoading = false
      } catch(e) {
        this.cartIsLoading = false
        console.log(''+e);

        this.$api.post('/order/error', {
          error: ''+e,
          statusCode: 505,
          storeId: this.getStore.storeId
        })
      } finally {
        this.isCheckingOut = false
      }
    },


    isWeChat() {
      const ua = navigator.userAgent.toLowerCase()
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        return true
      } else {
        return false
      }
    },
    closeAddCart() {
      document.getElementById('menu-item-content').scrollTop = 0
      this.$store.dispatch('closeMenuItemDialog')
      this.$store.dispatch('setIsCartItem', false)
      this.$store.commit('SET_IS_OPTION', false)
    }
  },

  watch: {
    // DEV-11115: refresh the AI row whenever the set of items in the cart changes --
    // covers the initial load, adds made through the item dialog, and removals, in one
    // place instead of a dispatch at each call site. Watches the joined codes (a string)
    // rather than the item list itself: the cart object is replaced wholesale on every
    // server response, so a reference watcher would re-fire the 3-8s LLM call on an
    // unrelated change (a tip edit, a coupon), while a quantity bump doesn't change
    // which items the model is told about. immediate so the first render fetches.
    aiCartRecommendationsCartKey: {
      immediate: true,
      handler(key, oldKey) {
        if (!key) return
        // Fetch only when the row can't fill its slots from the picks it already has. Adds and
        // removals don't refetch while it can: the getter hides picks that are in the cart,
        // shows them again once removed, and fills a gap from the spares it fetched.
        // DEV-11344 QA: refetch whenever fewer than a full row is left (not only at zero) --
        // e.g. picks the service left out because they were in the cart at fetch time never
        // come back on their own. Order type and login still refresh.
        if (this.getAiCartRecommendations && this.getAiCartRecommendations.length >= AI_CART_RECOMMENDATIONS_TO_SHOW) return
        this.fetchAiCartRecommendations()
      }
    },
    // Order type is part of the request (a Dine In pick isn't necessarily a Delivery
    // pick), so re-request when the guest switches it -- whenever the row is in use: the
    // cart has items, or it's already showing picks (e.g. an empty cart that was opened).
    // Not unconditionally: the order type is also set on page load, and Cart.vue is
    // mounted on every page, so that would fire the AI call for every visitor.
    getOrderType() {
      if (this.aiCartRecommendationsCartKey || this.$store.state.menu.aiCartRecommendations.length) {
        // Clear first so the old type's picks never show while the new ones load.
        this.$store.commit('SET_AI_CART_RECOMMENDATIONS', [])
        this.fetchAiCartRecommendations()
      }
    },
    // Re-sync groupOrderSession whenever Vuex groupOrder state changes.
    //
    // Reference watchers, not deep ones (DEV-11114): SET_GROUP_STATE assigns whatever the
    // API returned (a brand-new res.data object every time), so a reference change already
    // fires on every real update -- deep:true added nothing but a full traversal of every
    // participant's subOrderList/orderItemList on each one. For a host that ran per
    // CART_CHANGED from EVERY guest (see group-order-ws.service.js), three times over
    // (once per watcher), for a handler that only rebuilds one session object regardless.
    '$store.state.groupOrder.participantCart': function() { this.loadGroupOrderSession(); },
    '$store.state.groupOrder.participantCarts': function() { this.loadGroupOrderSession(); },
    '$store.state.groupOrder.group': function() { this.loadGroupOrderSession(); },
    // SET_CART_LOCKED patches locked/lockedReason on the EXISTING participantCart object
    // rather than replacing it, so the reference watcher above can't see it. Both fields
    // are surfaced by legacyGroupOrderSession, so watch them directly -- two scalar
    // watchers, not a deep traversal of the whole cart.
    '$store.state.groupOrder.participantCart.locked': function() { this.loadGroupOrderSession(); },
    '$store.state.groupOrder.participantCart.lockedReason': function() { this.loadGroupOrderSession(); },
    '$store.state.groupOrder.group.countdownEndsAt': function(newVal, oldVal) {
      if (!oldVal || !newVal || newVal === oldVal) return;
      const isHost = this.$store.state.groupOrder && this.$store.state.groupOrder.isHost;
      if (isHost) return;
      const tz = (this.getStore && this.getStore.timeZone) || 'America/Toronto';
      const d = new Date(newVal);
      const timeStr = isNaN(d.getTime()) ? '' : d.toLocaleDateString(getDisplayLocale(this.$vuetify.lang.current), { month: 'short', day: 'numeric', timeZone: tz }) + ' at ' + d.toLocaleTimeString(getDisplayLocale(this.$vuetify.lang.current), { hour: 'numeric', minute: '2-digit', timeZone: tz });
      this.$store.dispatch('showSnack', {
        text: timeStr ? this.$vuetify.t('$vuetify.groupOrder.deadlineUpdated', [timeStr]) : this.$vuetify.t('$vuetify.groupOrder.deadlineRemoved'),
        color: 'primary',
        timeout: 5000,
      });
    },
    '$store.state.groupOrder.removed': function(removed) {
      if (removed) {
        // Clear local session display when host removes this participant
        this.groupOrderSession = null;
      }
    },

    displayedCartErrorMessage(to, from) {
      // Group orders: getOrderItemList already resolves to the participant cart's own
      // items (see its own definition) -- same "has items" check as getLocalCart/
      // getExistingOrder below, just group-order-aware. Watches displayedCartErrorMessage
      // (guest-scoped item-level errors for a guest, unchanged cartErrorMessage for the
      // host/solo cart), not cartErrorMessage directly -- see its own comment for why.
      const hasItems = this.groupOrderSession
        ? (this.getOrderItemList && this.getOrderItemList.length)
        : ((this.getLocalCart && this.getLocalCart.length) || (this.getExistingOrder && this.getExistingOrder.length))
      if (this.displayedCartErrorMessage && hasItems) {
        this.$store.dispatch('showSnack', {
          text: this.displayedCartErrorMessage,
          color: 'error'
        })
      }
    },

    'getServerCart.total'() {
      if ((this.cartErrorMessage && this.cartErrorMessage == this.deliveryMinMsg) && !this.groupOrderSession && ( (this.getLocalCart && this.getLocalCart.length) || (this.getExistingOrder && this.getExistingOrder.length))) {
        this.$store.dispatch('showSnack', {
          text: this.cartErrorMessage,
          color: 'error'
        })
      }
    }
  }
};
</script>

<style scoped>
  .errorStatus {
  max-width: 100% !important 
  }
  #storeName {
    font-size: var(--text-size-2);
    font-weight: 700;

    margin-top: 10px;
  }

  .cart-view {
    width: 100% !important;
    max-width: 100% !important;
    overflow-x: hidden !important;
    position: relative;
  }

  .cart-view.desktopCart {
    max-height: 80vh;
    overflow-y: auto;
    width: 100% !important;
  }
  .cart-view.mobileCart {
    height: calc(100dvh - 64px);
    overflow-y: auto;
    padding-bottom: max(20px, env(safe-area-inset-bottom));
    width: 100% !important;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior: contain;
  }
  .cart-list-container {
    width: 100% !important;
    max-width: 100% !important;
    overflow-x: hidden !important;
    box-sizing: border-box !important;
  }

  .has-errors {
    background: #ffdada;
    border-left: red solid 5px;
    color: darkred;
  }

  .strikethrough {
    text-decoration: line-through;
    text-decoration-color: red;
  }
  .cart-qty {
    width: 24px;
    text-align: center;
  }

  .card-item {
    font-size: 12px;
  }

  .cart-totals {
    text-align: left;
    padding: 10px 15px;
    font-size: var(--text-size-1);
    border-top: 1px solid #D9D9D9;
    border-bottom: 1px solid #D9D9D9;
    max-width: 100% !important;
    width: 100% !important;
    box-sizing: border-box !important;
  }

  .cart-totals > div {
    margin-bottom: 4px;
  }

  .cart-totals > div > div > :first-child {
    text-align: right;
    justify-self: end;
  }

  .cart-totals span {
    float: right;
  }

  .cart-totals .coupon-item {
    display: grid;
    grid-template-columns: auto 1fr auto;
    gap: 8px;
    align-items: center;
  }
  .cart-faded {
    display: flex; 
    justify-content: space-between;
    align-items: center;
    width: 100%;
    color: #7d7d7d;
  }

  .cart-grand-total {
    font-weight: 600;
    color: var(--v-primary-base);
  }

  .cart-list {
    padding: 0px;
    list-style: none;
  }
  .v-expansion-panel {
    box-shadow: 0px 0px 0px 0px rgba(0,0,0,.2)
  }
  .special-request {
    color: #999999;
    word-break: break-word;
    overflow-wrap: break-word;
  }
  .cart-alert {
    display: flex;
    justify-content: center;
    padding: 10px 0 20px;
    color: #999999;
  }

  #checkBtn {
    border-radius: 25px;
    margin-top: 20px;
    height: 50px;
    margin-right: 15px;
    margin-left: 15px;
    width: -webkit-fill-available !important;
  }

  .rounded-btn {
    border-radius: 25px;
    margin-left: 15px;
    margin-right: 15px;
    width: -webkit-fill-available !important;
    margin-bottom: 20px;
    height: 50px;
  }

  #footerContainer {
    padding-bottom: 20px;
    width: 100% !important;
    max-width: 100% !important;
    box-sizing: border-box !important;
  }
  #footerContainer.go-footer {
    padding-bottom: 0;
  }

  .poweredBy {
    font-size: 12px;

    padding: 20px 0px 15px;

    width: 100%;
    background-color: white;
  }

  hr {
    border: none;
    height: 1px;
    background-color: #D9D9D9; 
    margin: 0;
  }

  .free-item {
    background-color: rgba(230, 230, 230, 0.5);
  }
  .adding {
    font-size: 13px;
  }
</style>

<style>
  .CardContainer, .PunchCards {
    margin: auto !important;
  }

  .cart-view + .v-navigation-drawer__border {
    display: none
  }

  .go-inline-confirm {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.45);
    z-index: 300;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
  }

  .go-inline-confirm-card {
    background: white;
    border-radius: 20px;
    padding: 12px 16px 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    text-align: center;
    width: 100%;
    max-width: 320px;
    max-height: 90vh;
  }

  .go-unready-confirm-card {
    max-width: 420px;
  }
</style>

<style scoped>
.cart-promotions-container {
  border-radius: 8px;
  padding-top: 8px;
  overflow: hidden;
}

.promo-header {
  background-color: white;
  padding: 12px 16px;
  margin-bottom: 8px;
}

.field-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

.cart-promo-list {
  padding: 0;
  display: block;
}

.promo-card {
  display: block;
  width: 100%;
  margin-bottom: 8px;
  background-color: white;
  border-radius: 8px;
  /* box-shadow: 0 1px 3px rgba(0,0,0,0.1); */
  align-items: center;
}

@media only screen and (max-width: 600px) {
  .cart-promotions-container {
    margin-left: -8px;
    margin-right: -8px;
    border-radius: 0;
  }
  
  .promo-card {
    margin-bottom: 8px;
  }
  .CardContainer, .PunchCards {
    margin: auto !important;
    /* Fixed empty ruleset */
  }
}
</style>

<style scoped>
/* ── Group Order Cart Header ── */
.go-cart-header {
  padding: 0px 16px 10px;
  border-bottom: 1px solid #eee;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.go-cart-title-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 4px;
}
.go-cart-title {
  font-size: 16px;
  font-weight: 700;
  color: #111;
}
.go-invite-panel {
  padding: 16px;
  border-bottom: 1px solid #eee;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  background: #fafafa;
}
.go-invite-panel-title {
  font-size: 14px;
  font-weight: 700;
  color: #111;
  align-self: flex-start;
}
.go-invite-qr {
  width: 160px;
  height: 160px;
  border-radius: 8px;
}
.go-invite-link-row {
  width: 100%;
  background: #f0f0f0;
  border-radius: 8px;
  padding: 8px 10px;
  overflow: hidden;
}
.go-invite-link-text {
  font-size: 11px;
  color: #555;
  word-break: break-all;
}
.go-invite-copy-btn {
  width: 100%;
  background: var(--v-primary-base);
  color: white;
  border: none;
  border-radius: 20px;
  padding: 10px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}
.go-menu-wrap {
  position: relative;
}
.go-menu-btn {
  background: var(--v-primary-base);
  border: none;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.go-menu-dropdown {
  position: absolute;
  right: 0;
  top: 36px;
  background: white;
  border: 1px solid #eee;
  border-radius: 10px;
  box-shadow: 0 4px 16px rgba(0,0,0,0.12);
  min-width: 180px;
  z-index: 100;
  overflow: hidden;
}
.go-menu-item {
  display: block;
  width: 100%;
  padding: 12px 16px;
  text-align: left;
  background: none;
  border: none;
  font-size: 14px;
  cursor: pointer;
}
.go-menu-item:hover {
  background: #f5f5f5;
}
.go-menu-item-danger {
  color: #e53935;
}
.go-cart-meta {
  display: flex;
  align-items: baseline;
  gap: 6px;
  font-size: 13px;
  line-height: 1.6;
}
.go-cart-meta-label {
  color: #aaa;
  min-width: 72px;
  flex-shrink: 0;
  text-align: left;
}
.go-cart-meta-value {
  color: #222;
  font-weight: 400;
}
.go-deadline-row {
  display: flex;
  align-items: center;
  gap: 10px;
  background: #f2f2f2;
  padding: 10px 16px;
  margin-top: 6px;
  margin-left: -16px;
  margin-right: -16px;
}
.go-deadline-row--editable {
  cursor: pointer;
}
.go-deadline-row--editable:hover {
  background: #ececec;
}
.go-deadline-icon-wrap {
  background: #222;
  border-radius: 50%;
  width: 26px;
  height: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.go-deadline-text {
  flex: 1;
  font-size: 13px;
  font-weight: 700;
  color: #111;
}
.go-deadline-edit-icon {
  color: #999;
  flex-shrink: 0;
}
.go-locked-banner {
  background: #fff3f3;
  color: #c0392b;
  font-size: 13px;
  font-weight: 500;
  padding: 6px 16px;
  text-align: center;
}
.go-locked-banner-host {
  background: #fff8e1;
  color: #b26a00;
}

/* ── Your Items section ── */
.go-your-items-title {
  font-size: 15px;
  font-weight: 700;
  color: #111;
  padding: 12px 16px 0;
  text-align: left;
}
.go-my-name-row {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 16px 0;
  font-size: 15px;
  font-weight: 600;
  color: #222;
  text-align: left;
}

/* ── Others section ── */
.go-section-divider {
  margin: 8px 0 0;
  border: none;
  border-top: 1px solid #e0e0e0;
}
.go-others-section {
  padding: 0;
  max-height: 320px;
  overflow-y: auto;
}
.go-others-title {
  font-size: 15px;
  font-weight: 700;
  color: #111;
  padding: 12px 16px 0;
  text-align: left;
}
.go-others-sub {
  font-size: 12px;
  color: #aaa;
  padding: 2px 16px 4px;
  text-align: left;
}
.go-others-section >>> .v-expansion-panel {
  box-shadow: none !important;
  margin: 10px 0 !important;
}
.go-others-section >>> .v-expansion-panel__container {
  border-top: none !important;
}
.go-others-section >>> .v-expansion-panel__header {
  padding: 10px 16px !important;
  min-height: 40px !important;
}
.go-member-row {
  display: flex;
  align-items: center;
  gap: 8px;
}
.go-member-name-block {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.go-member-name {
  font-size: 15px;
  font-weight: 600;
  color: #222;
}
.go-member-name--empty {
  color: #bbb;
  font-weight: 500;
}
.go-member-status-row {
  display: flex;
  align-items: center;
  gap: 4px;
}
.go-member-ready-badge {
  font-size: 12px;
  font-weight: 600;
  color: #22c55e;
}
.go-member-waiting-badge {
  font-size: 12px;
  font-weight: 500;
  color: #f59e0b;
}
.go-member-item-count {
  font-size: 12px;
  color: #888;
}
.go-member-error-badge {
  font-size: 12px;
  font-weight: 600;
  color: #e90e10;
}
.go-readiness-list {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  text-align: left;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
}
.go-readiness-row {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
}
.go-member-items-body {
  padding: 0 16px 10px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.go-member-item-row-wrap {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.go-member-item-row {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #222;
}
.go-member-item-special-request {
  font-size: 12px;
  color: #999;
  padding-left: 32px;
  word-break: break-word;
  overflow-wrap: break-word;
}
.go-member-item-qty {
  color: #888;
  min-width: 24px;
  font-size: 14px;
}
.go-member-item-controls {
  display: flex;
  align-items: center;
  gap: 2px;
}
.go-qty-btn {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  color: var(--v-primary-base);
  display: flex;
  align-items: center;
}
.go-qty-num {
  font-size: 14px;
  font-weight: 600;
  min-width: 18px;
  text-align: center;
}
.go-member-item-name {
  flex: 1;
  font-size: 14px;
}
.go-member-item-price {
  font-size: 14px;
  font-weight: 600;
}
.go-member-empty {
  font-size: 13px;
  color: #bbb;
}
.go-action-btns {
  padding: 12px 16px 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.go-ready-status {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  color: #2e7d32;
  font-size: 14px;
  font-weight: 600;
}
.go-ready-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #43a047;
  flex-shrink: 0;
}
.go-ready-btn {
  width: 100%;
  background: var(--v-primary-base);
  border: none;
  border-radius: 30px;
  padding: 15px;
  font-size: 16px;
  font-weight: 700;
  color: white;
  cursor: pointer;
  transition: opacity 0.2s;
}
.go-ready-btn:hover {
  opacity: 0.88;
}
.go-ready-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.go-locked-btn {
  width: 100%;
  background: #e0e0e0;
  border: none;
  border-radius: 30px;
  padding: 15px;
  font-size: 16px;
  font-weight: 600;
  color: #999;
  cursor: not-allowed;
}
.go-add-items-outline-btn {
  width: 100%;
  background: transparent;
  border: 2px solid var(--v-primary-base);
  border-radius: 30px;
  padding: 13px;
  font-size: 16px;
  font-weight: 700;
  color: var(--v-primary-base);
  cursor: pointer;
  transition: opacity 0.2s;
}
.go-add-items-outline-btn:hover {
  opacity: 0.8;
}

.go-cancel-group-btn {
  background: transparent;
  border: none;
  color: #e53935;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  padding: 6px 0;
  margin-top: 4px;
  text-decoration: underline;
}
.go-member-actions {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 10px;
  padding: 0 16px 4px;
}

.go-remove-member-btn {
  background: transparent;
  border: 1.5px solid #ddd;
  border-radius: 22px;
  padding: 9px 16px;
  color: #555;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  width: 100%;
  text-align: center;
}

.go-unlock-member-btn {
  background: var(--v-primary-base);
  border: none;
  border-radius: 22px;
  padding: 9px 16px;
  color: white;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  width: 100%;
  text-align: center;
}

.go-remove-confirm-card {
  border-radius: 20px !important;
  padding: 24px 20px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  position: relative;
  text-align: center;
}

.go-remove-confirm-x {
  align-self: flex-end;
  background: #e0e0e0;
  border: none;
  border-radius: 50%;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.go-remove-confirm-title {
  font-size: 17px;
  font-weight: 700;
  color: #222;
  line-height: 1.4;
  margin-top: 0;
}

.go-remove-confirm-sub {
  font-size: 13px;
  color: #888;
  line-height: 1.5;
}

.go-remove-confirm-btn {
  width: 100%;
  background: #e53935;
  border: none;
  border-radius: 25px;
  padding: 14px;
  font-size: 15px;
  font-weight: 700;
  color: white;
  cursor: pointer;
}

.go-remove-cancel-btn {
  width: 100%;
  background: transparent;
  border: 1.5px solid #ddd;
  border-radius: 25px;
  padding: 13px;
  font-size: 15px;
  font-weight: 600;
  color: #888;
  cursor: pointer;
}

.go-checkout-confirm-btn {
  background: var(--v-primary-base) !important;
}

.go-remove-carts-checkout-btn {
  width: 100%;
  background: transparent;
  border: 1.5px solid #e53935;
  border-radius: 25px;
  padding: 13px;
  font-size: 15px;
  font-weight: 700;
  color: #e53935;
  cursor: pointer;
  margin-bottom: 10px;
}
.go-remove-carts-checkout-btn:hover {
  background: rgba(229, 57, 53, 0.06);
}
.go-remove-carts-checkout-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.go-checkout-back-btn {
  border-color: var(--v-primary-base);
  color: var(--v-primary-base);
}

/* ── Shared Cart ─────────────────────────────────────────────── */
.sc-banner {
  display: flex;
  align-items: center;
  background: var(--v-primary-base);
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  padding: 8px 12px;
  margin-bottom: 4px;
}

.sc-ordered-panel {
  background: #f5f5f5;
  margin: 0 -1px 8px;
  padding-bottom: 4px;
}

.sc-panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 12px;
  background: transparent;
  border: none;
  text-align: left;
  cursor: pointer;
}

.sc-panel-title {
  font-size: 17px;
  font-weight: 700;
  color: #1a1a1a;
}

.sc-round-summary-list {
  padding: 0 12px 8px;
}

.sc-round-summary-row {
  font-size: 13px;
  font-weight: 700;
  color: #555;
  padding: 2px 0;
}

.sc-round-group + .sc-round-group {
  border-top: 1px solid #e0e0e0;
  margin-top: 4px;
  padding-top: 4px;
}

.sc-connected-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #4caf50;
  margin-left: 8px;
}

.sc-stale-badge {
  font-size: 11px;
  color: #e65100;
  background: #fff3e0;
  border-left: 3px solid #e65100;
  padding: 2px 8px;
  margin: 2px 0 4px;
}

.sc-section-header {
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: #888;
  padding: 10px 12px 4px;
}

.sc-round-header {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
}

.sc-draft-header {
  padding: 12px 12px 4px;
}

.sc-draft-title {
  /* Same size and weight as "Already ordered" (.sc-panel-title) so both
     section titles read as equally prominent. */
  font-size: 17px;
  font-weight: 700;
  color: #1a1a1a;
}

.sc-draft-count {
  font-size: 13px;
  font-weight: 700;
  text-transform: none;
  letter-spacing: normal;
  color: #1a1a1a;
  margin-top: 2px;
}

.sc-round-time {
  font-size: 11px;
  font-weight: 600;
  text-transform: none;
  letter-spacing: normal;
  color: #aaa;
}

.sc-sent-item {
  opacity: 0.65;
  pointer-events: none;
}

.sc-action-btns {
  padding: 12px 16px 8px;
}

.sc-fire-btn {
  width: 100%;
  padding: 12px;
  background: var(--v-primary-base);
  color: #fff;
  font-size: 15px;
  font-weight: 700;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  letter-spacing: 0.3px;
}

.sc-fire-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.go-checkout-btn-with-subtext {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.go-checkout-btn-title {
  font-size: 15px;
  font-weight: 700;
}
.go-checkout-btn-subtext {
  font-size: 12px;
  font-weight: 400;
  opacity: 0.8;
}
</style>
